webpackJsonp([2],{

/***/ "./node_modules/@justgiving/dna-card/lib/RelatedStory/RelatedStory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dnaProgress = __webpack_require__("./node_modules/@justgiving/dna-progress/lib/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelatedStory = function (_Component) {
  _inherits(RelatedStory, _Component);

  function RelatedStory() {
    _classCallCheck(this, RelatedStory);

    return _possibleConstructorReturn(this, (RelatedStory.__proto__ || Object.getPrototypeOf(RelatedStory)).apply(this, arguments));
  }

  _createClass(RelatedStory, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          showTotaliser = _props.showTotaliser,
          componentDidMountCallback = _props.componentDidMountCallback,
          id = _props.id;

      if (showTotaliser) {
        var totaliser = new _dnaProgress.Totaliser(this.totalizer, {
          duration: 1000
        });

        totaliser.init();
      }
      if (componentDidMountCallback) {
        componentDidMountCallback(id);
      }
    }
  }, {
    key: 'handleRenderTotaliser',
    value: function handleRenderTotaliser() {
      var _this2 = this;

      var percentage = this.props.percentage;


      return _react2.default.createElement(
        'div',
        {
          ref: function ref(c) {
            return _this2.totalizer = c;
          },
          className: 'js-dna-totaliser related-story-totaliser totaliser dna-totaliser-s fdr-media-block-media theme-secondary-background',
          'data-percentage': this.props.percentage
        },
        _react2.default.createElement('div', { className: 'dna-totaliser-background' }),
        _react2.default.createElement(
          'div',
          { className: 'dna-totaliser-level-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'dna-totaliser-level' },
            _react2.default.createElement(
              'svg',
              {
                className: 'dna-totaliser-wave',
                xmlns: 'http://www.w3.org/2000/svg',
                version: '1.1',
                viewBox: '531 215.9 1658 411'
              },
              _react2.default.createElement('path', {
                className: 'dna-totaliser-wave-path',
                d: 'M531,626.9h1658V216.1c0,0-68.1,2-147.1,13.3c-88.6,6.8-106.7,12.1-209.5-1.3c-71.4-9.3-120.5-8-191,1  c-72.7,7.1-112.7,7.1-174.8,1.9c-182-25.9-227.4-1.4-333.3-4.3c-62.3-1.7-74.2-0.5-148.7-5c-68.5-4.2-74.2,5.3-167.6-1.6  c-71.6-5.3-286-4-286-4V626.9L531,626.9z'
              })
            )
          )
        ),
        _react2.default.createElement('span', { className: 'dna-totaliser-mask' }),
        _react2.default.createElement(
          'span',
          { className: 'dna-totaliser-ring' },
          _react2.default.createElement('span', null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'dna-totaliser-inner' },
          _react2.default.createElement(
            'span',
            { className: 'dna-totaliser-value' },
            percentage
          ),
          _react2.default.createElement(
            'span',
            { className: 'dna-totaliser-percentage' },
            '%'
          )
        )
      );
    }
  }, {
    key: 'handleMultipleSupporters',
    value: function handleMultipleSupporters() {
      var numberOfSupporters = this.props.numberOfSupporters;


      return numberOfSupporters !== 1 ? 's' : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          title = _props2.title,
          owner = _props2.owner,
          numberOfSupporters = _props2.numberOfSupporters,
          totalRaised = _props2.totalRaised,
          pageImage = _props2.pageImage,
          ownerAvatar = _props2.ownerAvatar,
          currencySymbol = _props2.currencySymbol,
          pageLink = _props2.pageLink,
          showTotaliser = _props2.showTotaliser,
          _onClick = _props2.onClick;


      return _react2.default.createElement(
        'div',
        { className: 'dna-card-container' },
        _react2.default.createElement(
          'a',
          {
            className: 'dna-card-anchor',
            href: pageLink,
            onClick: function onClick() {
              return _onClick && _onClick(id);
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'dna-card-page-image-container' },
            _react2.default.createElement('img', { className: 'dna-card-page-image', src: pageImage })
          ),
          _react2.default.createElement(
            'div',
            { className: 'dna-card-information-container' },
            _react2.default.createElement(
              'h4',
              { className: 'dna-h4 dna-card-title' },
              title
            ),
            _react2.default.createElement(
              'div',
              { className: 'dna-card-fundraiser-container' },
              _react2.default.createElement(
                'div',
                { className: 'dna-card-avatar-container' },
                _react2.default.createElement('img', { className: 'dna-card-fundraiser-avatar', src: ownerAvatar })
              ),
              _react2.default.createElement(
                'p',
                { className: 'dna-h5' },
                owner
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'dna-card-progress-container' },
              showTotaliser ? this.handleRenderTotaliser() : null,
              _react2.default.createElement(
                'div',
                { className: 'dna-card-progress-information-container' },
                _react2.default.createElement(
                  'p',
                  { className: 'dna-text-l' },
                  _react2.default.createElement(
                    'span',
                    { className: 'dna-text-brand-m' },
                    currencySymbol,
                    totalRaised,
                    ' '
                  ),
                  'raised by'
                ),
                _react2.default.createElement(
                  'p',
                  { className: 'dna-card-number-of-supporters' },
                  numberOfSupporters,
                  ' supporter',
                  this.handleMultipleSupporters()
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RelatedStory;
}(_react.Component);

RelatedStory.propTypes = {
  id: _propTypes2.default.string.isRequired,
  percentage: _propTypes2.default.number.isRequired,
  owner: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  numberOfSupporters: _propTypes2.default.number.isRequired,
  totalRaised: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
  showTotaliser: _propTypes2.default.bool.isRequired,
  pageImage: _propTypes2.default.string.isRequired,
  ownerAvatar: _propTypes2.default.string.isRequired,
  currencySymbol: _propTypes2.default.string,
  pageLink: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  componentDidMountCallback: _propTypes2.default.func
};
exports.default = RelatedStory;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.RelatedStory = undefined;

var _RelatedStory = __webpack_require__("./node_modules/@justgiving/dna-card/lib/RelatedStory/RelatedStory.js");

var _RelatedStory2 = _interopRequireDefault(_RelatedStory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RelatedStory = _RelatedStory2.default;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/KeyEscapeUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/PooledClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/reactProdInvariant.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/React.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactBaseClasses = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactBaseClasses.js");
var ReactChildren = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactChildren.js");
var ReactDOMFactories = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactDOMFactories.js");
var ReactElement = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js");
var ReactPropTypes = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactPropTypes.js");
var ReactVersion = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactVersion.js");

var createReactClass = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/createClass.js");
var onlyChild = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/onlyChild.js");

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactBaseClasses.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/reactProdInvariant.js"),
    _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactNoopUpdateQueue = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactNoopUpdateQueue.js");

var canDefineProperty = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/canDefineProperty.js");
var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var lowPriorityWarning = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/lowPriorityWarning.js");

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/PooledClass.js");
var ReactElement = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js");

var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var traverseAllChildren = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/traverseAllChildren.js");

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactCurrentOwner.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactDOMFactories.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js");

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactCurrentOwner.js");

var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
var canDefineProperty = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/canDefineProperty.js");
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElementSymbol.js");

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElementSymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactNoopUpdateQueue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js"),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__("./node_modules/prop-types/factory.js");

module.exports = factory(isValidElement);

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactVersion.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/canDefineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactBaseClasses.js"),
    Component = _require.Component;

var _require2 = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js"),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactNoopUpdateQueue.js");
var factory = __webpack_require__("./node_modules/create-react-class/factory.js");

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/getIteratorFn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/lowPriorityWarning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/onlyChild.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/reactProdInvariant.js");

var ReactElement = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElement.js");

var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/reactProdInvariant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/lib/traverseAllChildren.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/reactProdInvariant.js");

var ReactCurrentOwner = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactCurrentOwner.js");
var REACT_ELEMENT_TYPE = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/ReactElementSymbol.js");

var getIteratorFn = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/getIteratorFn.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var KeyEscapeUtils = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/KeyEscapeUtils.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),

/***/ "./node_modules/@justgiving/dna-card/node_modules/react/react.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("./node_modules/@justgiving/dna-card/node_modules/react/lib/React.js");


/***/ }),

/***/ "./node_modules/@justgiving/dna-progress/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Totaliser = undefined;

var _totaliser = __webpack_require__("./node_modules/@justgiving/dna-progress/lib/totaliser/totaliser.js");

var _totaliser2 = _interopRequireDefault(_totaliser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Totaliser = _totaliser2.default;

/***/ }),

/***/ "./node_modules/@justgiving/dna-progress/lib/totaliser/totaliser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Totaliser = function () {

	/**
 	* Totaliser constructor
 	* @param {number} option.duration - max duration of animation in milliseconds
 */
	function Totaliser(el) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Totaliser);

		// mandatory selector element
		this._el = el;

		// options
		this._maxDuration = options.duration || 6000;

		this._percentage = this._el.dataset.percentage;
		this._duration = this._setDuration();

		this._domEls = {
			value: this._el.querySelector('.dna-totaliser-value'),
			level: this._el.querySelector('.dna-totaliser-level')
		};

		this._elRingBorderSize = this._el.querySelector('.dna-totaliser-ring').clientLeft;
		this._elRingInnerBorderSize = this._el.querySelector('.dna-totaliser-ring span').clientLeft;
		this._levelOffset = this._elRingBorderSize + this._elRingInnerBorderSize;
		this._incrementVal = this._duration / this._percentage;

		this._startTime = null;
		this._frameVal = 0;
		this._digitsThree = false;
		this._digitsFour = false;
		this._digitsFive = false;
	}

	//-------------------------------------------------
	// PRIVATE METHODS
	//-------------------------------------------------
	// ease out


	_createClass(Totaliser, [{
		key: '_easeOutExpo',
		value: function _easeOutExpo(t, b, c, d) {
			return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
		}

		// linear ease
		// _easeLinear(t) {
		// 	return this._percentage * (t / this._duration);
		// }

		// set duration depending on percentage value

	}, {
		key: '_setDuration',
		value: function _setDuration() {
			switch (true) {
				case this._percentage >= 99:
					{
						return this._maxDuration;
					}
				case this._percentage >= 71:
					{
						return this._maxDuration / 1.5;
					}
				case this._percentage >= 36:
					{
						return this._maxDuration / 2;
					}
				case this._percentage >= 11:
					{
						return this._maxDuration / 3;
					}
				default:
					return this._maxDuration / 5;
			}
		}

		// set font sizes depending on value

	}, {
		key: '_setFontSize',
		value: function _setFontSize(value) {
			switch (true) {
				case value > 9999:
					{
						if (!this._digitsFive) {
							this._el.classList.add('digits-five');
							this._el.classList.remove('digits-four');
						}
						this._digitsFive = true;
						break;
					}
				case value > 999:
					{
						if (!this._digitsFour) {
							this._el.classList.add('digits-four');
							this._el.classList.remove('digits-three');
						}
						this._digitsFour = true;
						break;
					}
				case value > 99:
					{
						if (!this._digitsThree) {
							this._el.classList.add('digits-three');
						}
						this._digitsThree = true;
						break;
					}
				default:
					return;
			}
		}

		// set start value & trigger count

	}, {
		key: '_setPercentageValue',
		value: function _setPercentageValue() {
			var _this = this;

			window.requestAnimationFrame(function (requestTime) {
				_this._onCount(requestTime);
			});
		}

		// set inline totaliser level styles

	}, {
		key: '_setTotaliserLevelStyles',
		value: function _setTotaliserLevelStyles() {
			var levelSize = this._percentage < 100 ? this._percentage : 100;

			this._domEls.level.style.transition = 'bottom ' + this._setDuration() / 1000 + 's, left ' + this._setDuration() / 1000 + 's';
			this._domEls.level.style.height = levelSize + '%';
			this._domEls.level.style.bottom = '-' + levelSize + '%';
		}

		// set inline totaliser animation styles

	}, {
		key: '_setTotaliserAnimation',
		value: function _setTotaliserAnimation() {
			this._el.classList.add('is-active');
		}

		//-------------------------------------------------
		// ON EVENT METHODS
		//-------------------------------------------------

		// increment totaliser value

	}, {
		key: '_onCount',
		value: function _onCount(timestamp) {
			var _this = this;
			var progress = void 0;

			if (!this._startTime) {
				this._startTime = timestamp;
			}

			progress = timestamp - this._startTime;

			if (progress < this._duration) {
				this._frameVal = this._easeOutExpo(progress, 0, this._percentage - 0, this._setDuration());
				// this._frameVal = this._easeLinear(progress);
				this._domEls.value.innerHTML = Math.round(this._frameVal);

				_this._setFontSize(Math.round(this._frameVal));

				window.requestAnimationFrame(function (requestTime) {
					_this._onCount(requestTime);
				});
			} else {
				_this._setFontSize(this._percentage);
				this._domEls.value.innerHTML = this._percentage;
			}
		}

		//-------------------------------------------------
		// PUBLIC METHODS
		//-------------------------------------------------

		// initialise class

	}, {
		key: 'init',
		value: function init() {
			var _this2 = this;

			this._setTotaliserLevelStyles();

			setTimeout(function () {
				_this2._setTotaliserAnimation();
				_this2._setPercentageValue();
			}, 750);
		}
	}]);

	return Totaliser;
}();

exports.default = Totaliser;

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("./node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("./node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("./node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js");
var getKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_is-object.js");
var toObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var toIObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopd.js");
var $GOPS = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gops.js");
var $DP = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "./node_modules/classnames/bind.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/component-classes/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__("./node_modules/component-indexof/index.js");
} catch (err) {
  var index = __webpack_require__("./node_modules/component-indexof/index.js");
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),

/***/ "./node_modules/component-indexof/index.js":
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ "./node_modules/consolidated-events/lib/TargetEventHandlers.js":
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventOptionsKey = __webpack_require__("./node_modules/consolidated-events/lib/eventOptionsKey.js");

var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

var TargetEventHandlers = function () {
  function TargetEventHandlers(target) {
    _classCallCheck(this, TargetEventHandlers);

    this.target = target;
    this.events = {};
  }

  _createClass(TargetEventHandlers, [{
    key: 'getEventHandlers',
    value: function () {
      function getEventHandlers(eventName, options) {
        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));

        if (!this.events[key]) {
          this.events[key] = {
            handlers: [],
            handleEvent: undefined
          };
          this.events[key].nextHandlers = this.events[key].handlers;
        }

        return this.events[key];
      }

      return getEventHandlers;
    }()
  }, {
    key: 'handleEvent',
    value: function () {
      function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function (handler) {
          if (handler) {
            // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
          }
        });
      }

      return handleEvent;
    }()
  }, {
    key: 'add',
    value: function () {
      function add(eventName, listener, options) {
        var _this = this;

        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);

        ensureCanMutateNextEventHandlers(eventHandlers);

        if (eventHandlers.nextHandlers.length === 0) {
          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }

        eventHandlers.nextHandlers.push(listener);

        var isSubscribed = true;
        var unsubscribe = function () {
          function unsubscribe() {
            if (!isSubscribed) {
              return;
            }

            isSubscribed = false;

            ensureCanMutateNextEventHandlers(eventHandlers);
            var index = eventHandlers.nextHandlers.indexOf(listener);
            eventHandlers.nextHandlers.splice(index, 1);

            if (eventHandlers.nextHandlers.length === 0) {
              // All event handlers have been removed, so we want to remove the event
              // listener from the target node.

              if (_this.target) {
                // There can be a race condition where the target may no longer exist
                // when this function is called, e.g. when a React component is
                // unmounting. Guarding against this prevents the following error:
                //
                //   Cannot read property 'removeEventListener' of undefined
                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
              }

              eventHandlers.handleEvent = undefined;
            }
          }

          return unsubscribe;
        }();
        return unsubscribe;
      }

      return add;
    }()
  }]);

  return TargetEventHandlers;
}();

exports['default'] = TargetEventHandlers;

/***/ }),

/***/ "./node_modules/consolidated-events/lib/canUseDOM.js":
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports['default'] = CAN_USE_DOM;

/***/ }),

/***/ "./node_modules/consolidated-events/lib/canUsePassiveEventListeners.js":
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = canUsePassiveEventListeners;

var _canUseDOM = __webpack_require__("./node_modules/consolidated-events/lib/canUseDOM.js");

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
function testPassiveEventListeners() {
  if (!_canUseDOM2['default']) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    window.addEventListener('test', null, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

/***/ }),

/***/ "./node_modules/consolidated-events/lib/eventOptionsKey.js":
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = eventOptionsKey;
/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

/***/ }),

/***/ "./node_modules/consolidated-events/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_HANDLERS_KEY = undefined;
exports.addEventListener = addEventListener;
exports.removeEventListener = removeEventListener;

var _normalizeEventOptions = __webpack_require__("./node_modules/consolidated-events/lib/normalizeEventOptions.js");

var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);

var _TargetEventHandlers = __webpack_require__("./node_modules/consolidated-events/lib/TargetEventHandlers.js");

var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Export to make testing possible.
var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
  }
  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

// Deprecated
function removeEventListener(unsubscribeFn) {
  unsubscribeFn();
}

/***/ }),

/***/ "./node_modules/consolidated-events/lib/normalizeEventOptions.js":
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = normalizeEventOptions;

var _canUsePassiveEventListeners = __webpack_require__("./node_modules/consolidated-events/lib/canUsePassiveEventListeners.js");

var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!(0, _canUsePassiveEventListeners2['default'])()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/***/ }),

/***/ "./node_modules/create-react-class/factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("./node_modules/object-assign/index.js");

var emptyObject = __webpack_require__("./node_modules/fbjs/lib/emptyObject.js");
var _invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "./node_modules/css-animation/es/Event.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
      var baseEvents = EVENT_NAME_MAP[baseEventName];
      for (var styleName in baseEvents) {
        if (styleName in style) {
          endEvents.push(baseEvents[styleName]);
          break;
        }
      }
    }
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },


  endEvents: endEvents,

  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),

/***/ "./node_modules/css-animation/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__("./node_modules/css-animation/es/Event.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__("./node_modules/component-classes/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),

/***/ "./node_modules/fbjs/lib/emptyObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ "./node_modules/fbjs/lib/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),

/***/ "./node_modules/lodash/_baseDifference.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("./node_modules/lodash/_SetCache.js"),
    arrayIncludes = __webpack_require__("./node_modules/lodash/_arrayIncludes.js"),
    arrayIncludesWith = __webpack_require__("./node_modules/lodash/_arrayIncludesWith.js"),
    arrayMap = __webpack_require__("./node_modules/lodash/_arrayMap.js"),
    baseUnary = __webpack_require__("./node_modules/lodash/_baseUnary.js"),
    cacheHas = __webpack_require__("./node_modules/lodash/_cacheHas.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ "./node_modules/lodash/chunk.js":
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__("./node_modules/lodash/_baseSlice.js"),
    isIterateeCall = __webpack_require__("./node_modules/lodash/_isIterateeCall.js"),
    toInteger = __webpack_require__("./node_modules/lodash/toInteger.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ "./node_modules/lodash/difference.js":
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__("./node_modules/lodash/_baseDifference.js"),
    baseFlatten = __webpack_require__("./node_modules/lodash/_baseFlatten.js"),
    baseRest = __webpack_require__("./node_modules/lodash/_baseRest.js"),
    isArrayLikeObject = __webpack_require__("./node_modules/lodash/isArrayLikeObject.js");

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),

/***/ "./node_modules/prop-types/checkPropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "./node_modules/prop-types/factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__("./node_modules/prop-types/factoryWithTypeCheckers.js");
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),

/***/ "./node_modules/prop-types/factoryWithTypeCheckers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var warning = __webpack_require__("./node_modules/fbjs/lib/warning.js");
var assign = __webpack_require__("./node_modules/object-assign/index.js");

var ReactPropTypesSecret = __webpack_require__("./node_modules/prop-types/lib/ReactPropTypesSecret.js");
var checkPropTypes = __webpack_require__("./node_modules/prop-types/checkPropTypes.js");

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/rc-animate/es/Animate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("./node_modules/rc-animate/node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__ = __webpack_require__("./node_modules/rc-animate/es/ChildrenUtils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AnimateChild__ = __webpack_require__("./node_modules/rc-animate/es/AnimateChild.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_animate__ = __webpack_require__("./node_modules/rc-animate/es/util/animate.js");












var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_10__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),

/***/ "./node_modules/rc-animate/es/AnimateChild.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__("./node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("./node_modules/rc-animate/node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__("./node_modules/css-animation/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__("./node_modules/rc-animate/es/util/animate.js");










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),

/***/ "./node_modules/rc-animate/es/ChildrenUtils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),

/***/ "./node_modules/rc-animate/es/util/animate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),

/***/ "./node_modules/rc-animate/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("./node_modules/rc-animate/node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/rc-animate/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/rc-animate/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/rc-animate/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/rc-collapse/es/Collapse.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/rc-collapse/node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Panel__ = __webpack_require__("./node_modules/rc-collapse/es/Panel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__ = __webpack_require__("./node_modules/rc-collapse/es/openAnimationFactory.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







function toArray(activeKey) {
  var currentActiveKey = activeKey;
  if (!Array.isArray(currentActiveKey)) {
    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
  }
  return currentActiveKey;
}

var Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse(props) {
    _classCallCheck(this, Collapse);

    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));

    var _this$props = _this.props,
        activeKey = _this$props.activeKey,
        defaultActiveKey = _this$props.defaultActiveKey;

    var currentActiveKey = defaultActiveKey;
    if ('activeKey' in _this.props) {
      currentActiveKey = activeKey;
    }

    _this.state = {
      openAnimation: _this.props.openAnimation || Object(__WEBPACK_IMPORTED_MODULE_3__openAnimationFactory__["a" /* default */])(_this.props.prefixCls),
      activeKey: toArray(currentActiveKey)
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKey' in nextProps) {
        this.setState({
          activeKey: toArray(nextProps.activeKey)
        });
      }
      if ('openAnimation' in nextProps) {
        this.setState({
          openAnimation: nextProps.openAnimation
        });
      }
    }
  }, {
    key: 'onClickItem',
    value: function onClickItem(key) {
      var activeKey = this.state.activeKey;
      if (this.props.accordion) {
        activeKey = activeKey[0] === key ? [] : [key];
      } else {
        activeKey = [].concat(_toConsumableArray(activeKey));
        var index = activeKey.indexOf(key);
        var isActive = index > -1;
        if (isActive) {
          // remove active state
          activeKey.splice(index, 1);
        } else {
          activeKey.push(key);
        }
      }
      this.setActiveKey(activeKey);
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var activeKey = this.state.activeKey;
      var _props = this.props,
          prefixCls = _props.prefixCls,
          accordion = _props.accordion,
          destroyInactivePanel = _props.destroyInactivePanel;

      var newChildren = [];

      __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(this.props.children, function (child, index) {
        if (!child) return;
        // If there is no key provide, use the panel order as default key
        var key = child.key || String(index);
        var _child$props = child.props,
            header = _child$props.header,
            headerClass = _child$props.headerClass,
            disabled = _child$props.disabled;

        var isActive = false;
        if (accordion) {
          isActive = activeKey[0] === key;
        } else {
          isActive = activeKey.indexOf(key) > -1;
        }

        var props = {
          key: key,
          header: header,
          headerClass: headerClass,
          isActive: isActive,
          prefixCls: prefixCls,
          destroyInactivePanel: destroyInactivePanel,
          openAnimation: _this2.state.openAnimation,
          children: child.props.children,
          onItemClick: disabled ? null : function () {
            return _this2.onClickItem(key);
          }
        };

        newChildren.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props));
      });

      return newChildren;
    }
  }, {
    key: 'setActiveKey',
    value: function setActiveKey(activeKey) {
      if (!('activeKey' in this.props)) {
        this.setState({ activeKey: activeKey });
      }
      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          className = _props2.className,
          style = _props2.style;

      var collapseClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: collapseClassName, style: style },
        this.getItems()
      );
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Collapse.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  accordion: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

Collapse.defaultProps = {
  prefixCls: 'rc-collapse',
  onChange: function onChange() {},

  accordion: false,
  destroyInactivePanel: false
};

Collapse.Panel = __WEBPACK_IMPORTED_MODULE_2__Panel__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),

/***/ "./node_modules/rc-collapse/es/Panel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/rc-collapse/node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelContent__ = __webpack_require__("./node_modules/rc-collapse/es/PanelContent.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rc_animate__ = __webpack_require__("./node_modules/rc-animate/es/Animate.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var CollapsePanel = function (_Component) {
  _inherits(CollapsePanel, _Component);

  function CollapsePanel() {
    _classCallCheck(this, CollapsePanel);

    return _possibleConstructorReturn(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
  }

  _createClass(CollapsePanel, [{
    key: 'handleItemClick',
    value: function handleItemClick() {
      if (this.props.onItemClick) {
        this.props.onItemClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          style = _props.style,
          prefixCls = _props.prefixCls,
          header = _props.header,
          headerClass = _props.headerClass,
          children = _props.children,
          isActive = _props.isActive,
          showArrow = _props.showArrow,
          destroyInactivePanel = _props.destroyInactivePanel,
          disabled = _props.disabled;

      var headerCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
      var itemCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: itemCls, style: style, id: id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: headerCls,
            onClick: this.handleItemClick.bind(this),
            role: 'tab',
            'aria-expanded': isActive
          },
          showArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'arrow' }),
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_rc_animate__["a" /* default */],
          {
            showProp: 'isActive',
            exclusive: true,
            component: '',
            animation: this.props.openAnimation
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__PanelContent__["a" /* default */],
            {
              prefixCls: prefixCls,
              isActive: isActive,
              destroyInactivePanel: destroyInactivePanel
            },
            children
          )
        )
      );
    }
  }]);

  return CollapsePanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CollapsePanel.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  openAnimation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  header: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  headerClass: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

CollapsePanel.defaultProps = {
  showArrow: true,
  isActive: false,
  destroyInactivePanel: false,
  onItemClick: function onItemClick() {},

  headerClass: ''
};

/* harmony default export */ __webpack_exports__["a"] = (CollapsePanel);

/***/ }),

/***/ "./node_modules/rc-collapse/es/PanelContent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("./node_modules/rc-collapse/node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var PanelContent = function (_Component) {
  _inherits(PanelContent, _Component);

  function PanelContent() {
    _classCallCheck(this, PanelContent);

    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
  }

  _createClass(PanelContent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.isActive || nextProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      this._isActived = this._isActived || this.props.isActive;
      if (!this._isActived) {
        return null;
      }
      var _props = this.props,
          prefixCls = _props.prefixCls,
          isActive = _props.isActive,
          children = _props.children,
          destroyInactivePanel = _props.destroyInactivePanel;

      var contentCls = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
      var child = !isActive && destroyInactivePanel ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: prefixCls + '-content-box' },
        children
      );
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: contentCls,
          role: 'tabpanel'
        },
        child
      );
    }
  }]);

  return PanelContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PanelContent.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  destroyInactivePanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (PanelContent);

/***/ }),

/***/ "./node_modules/rc-collapse/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__("./node_modules/rc-collapse/es/Collapse.js");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */]);
var Panel = __WEBPACK_IMPORTED_MODULE_0__Collapse__["a" /* default */].Panel;

/***/ }),

/***/ "./node_modules/rc-collapse/es/openAnimationFactory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_animation__ = __webpack_require__("./node_modules/css-animation/es/index.js");


function animate(node, show, transitionName, done) {
  var height = void 0;
  return Object(__WEBPACK_IMPORTED_MODULE_0_css_animation__["a" /* default */])(node, transitionName, {
    start: function start() {
      if (!show) {
        node.style.height = node.offsetHeight + 'px';
      } else {
        height = node.offsetHeight;
        node.style.height = 0;
      }
    },
    active: function active() {
      node.style.height = (show ? height : 0) + 'px';
    },
    end: function end() {
      node.style.height = '';
      done();
    }
  });
}

function animation(prefixCls) {
  return {
    enter: function enter(node, done) {
      return animate(node, true, prefixCls + '-anim', done);
    },
    leave: function leave(node, done) {
      return animate(node, false, prefixCls + '-anim', done);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (animation);

/***/ }),

/***/ "./node_modules/rc-collapse/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("./node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("./node_modules/fbjs/lib/invariant.js");
var ReactPropTypesSecret = __webpack_require__("./node_modules/rc-collapse/node_modules/prop-types/lib/ReactPropTypesSecret.js");

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/rc-collapse/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/rc-collapse/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/rc-collapse/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/react-waypoint/cjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var consolidatedEvents = __webpack_require__("./node_modules/consolidated-events/lib/index.js");
var PropTypes = _interopDefault(__webpack_require__("./node_modules/react-waypoint/node_modules/prop-types/index.js"));
var React = _interopDefault(__webpack_require__("./node_modules/react/index.js"));

/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      React.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

/**
 * Calls a function when you scroll to the element.
 */

var Waypoint = function (_React$Component) {
  _inherits(Waypoint, _React$Component);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly, we want to delay the initial execution until the
        // next tick.
        this.cancelInitialTimeout = onNextTick(function () {
          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = consolidatedEvents.addEventListener(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = consolidatedEvents.addEventListener(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved.
        this._handleScroll(null);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelInitialTimeout) {
          this.cancelInitialTimeout();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this3 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return React.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children)) {
          var ref = function () {
            function ref(node) {
              _this3.refElement(node);
              if (children.ref) {
                children.ref(node);
              }
            }

            return ref;
          }();

          return React.cloneElement(children, { ref: ref });
        }

        return React.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(React.Component);

Waypoint.propTypes = {
  children: PropTypes.node,
  debug: PropTypes.bool,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onPositionChange: PropTypes.func,
  fireOnRapidScroll: PropTypes.bool,
  scrollableAncestor: PropTypes.any,
  horizontal: PropTypes.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

module.exports = Waypoint;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/react-waypoint/node_modules/prop-types/factoryWithThrowingShims.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__("./node_modules/react-waypoint/node_modules/prop-types/lib/ReactPropTypesSecret.js");

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ "./node_modules/react-waypoint/node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("./node_modules/react-waypoint/node_modules/prop-types/factoryWithThrowingShims.js")();
}


/***/ }),

/***/ "./node_modules/react-waypoint/node_modules/prop-types/lib/ReactPropTypesSecret.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/timers-browserify/main.js":
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("./node_modules/setimmediate/setImmediate.js");
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ "./src/components/Carousel/Carousel.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_4N826","body":"_16tMR","carousel":"_2R0nD","slide":"_2cjpd","dots":"M2AXi","dot":"_2epsX","dot-active":"_13h51","navigation":"_2Py3s","next":"eX7YZ","previous":"_1G8Co","sr-only":"_3kmKs","sr-only-focusable":"_2_FCf"};

/***/ }),

/***/ "./src/components/Carousel/Carousel.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TipCarousel; });
/* unused harmony export PlaceholderCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Carousel_scss__ = __webpack_require__("./src/components/Carousel/Carousel.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Carousel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Carousel_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TipCarousel_scss__ = __webpack_require__("./src/components/Carousel/TipCarousel.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TipCarousel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TipCarousel_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaceholderCarousel_scss__ = __webpack_require__("./src/components/Carousel/PlaceholderCarousel.scss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaceholderCarousel_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PlaceholderCarousel_scss__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.pause = function () {
            if (_this.rotateInterval) {
                clearInterval(_this.rotateInterval);
            }
        };
        _this.resume = function () {
            var autoRotate = _this.props.autoRotate;
            if (autoRotate > 0) {
                _this.pause();
                _this.rotateInterval = window.setInterval(function () {
                    var children = _this.props.children;
                    var currentSlide = _this.state.currentSlide;
                    if (currentSlide === __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1) {
                        currentSlide = 0;
                    }
                    else {
                        currentSlide += 1;
                    }
                    _this.setIndex(currentSlide);
                }, autoRotate);
            }
        };
        _this.handlePrevious = function (event) {
            var currentSlide = _this.state.currentSlide;
            if (currentSlide === 0) {
                return;
            }
            _this.setIndex(currentSlide - 1 || 0, event);
        };
        _this.handleNext = function (event) {
            var currentSlide = _this.state.currentSlide;
            var children = _this.props.children;
            if (currentSlide === __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1) {
                return;
            }
            _this.setIndex(currentSlide + 1, event);
        };
        _this.handleDot = function (index) { return function (event) {
            var children = _this.props.children;
            if (index > __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1) {
                return;
            }
            if (index < 0) {
                return;
            }
            _this.setIndex(index, event);
        }; };
        _this.handleTouch = function (e) {
            var _a, _b, _c;
            _this.pause();
            var disableVerticalTouchMove = _this.props.disableVerticalTouchMove;
            var touch = e.touches[0];
            switch (e.type) {
                case 'touchstart':
                    _this.setState(__assign({}, _this.state, { touches: __assign({}, _this.state.touches, (_a = {}, _a[e.type] = {
                            x: touch.pageX,
                            y: touch.pageY,
                        }, _a.touchmove = {
                            x: touch.pageX,
                            y: touch.pageY,
                        }, _a.touchend = false, _a)) }));
                    break;
                case 'touchmove':
                    _this.setState(__assign({}, _this.state, { touches: __assign({}, _this.state.touches, (_b = {}, _b[e.type] = {
                            x: touch.pageX,
                            y: touch.pageY,
                        }, _b.touchend = false, _b)) }));
                    break;
                case 'touchend': {
                    if (_this.state.touches.touchstart.x > -1 &&
                        _this.state.touches.touchmove.x > -1) {
                        _this.setState(__assign({}, _this.state, { currentSlide: _this.moveSlide(e), touches: __assign({}, _this.state.touches, (_c = { direction: _this.state.touches.touchstart.x < _this.state.touches.touchmove.x
                                        ? 'right'
                                        : 'left', distance: {
                                        x: Math.abs(_this.state.touches.touchstart.x),
                                        y: Math.abs(_this.state.touches.touchstart.y),
                                    } }, _c[e.type] = true, _c)) }));
                    }
                    break;
                }
                default:
                    break;
            }
            if (disableVerticalTouchMove) {
                _this.preventScrolling(e);
            }
        };
        _this.state = {
            currentSlide: _this.props.defaultSlide || 0,
            touches: {
                touchstart: {
                    x: -1,
                    y: -1,
                },
                touchmove: {
                    x: -1,
                    y: -1,
                },
                distance: {
                    x: -1,
                    y: -1,
                },
                touchend: true,
                direction: null,
            },
        };
        return _this;
    }
    Carousel.prototype.componentDidMount = function () {
        var _a = this.props, touchable = _a.touchable, autoRotate = _a.autoRotate;
        if (touchable) {
            this.track.addEventListener('touchstart', this.handleTouch, false);
            this.track.addEventListener('touchmove', this.handleTouch, false);
            this.track.addEventListener('touchend', this.handleTouch, false);
        }
        if (autoRotate) {
            this.container.addEventListener('mouseenter', this.pause, false);
            this.container.addEventListener('mouseleave', this.resume, false);
            this.resume();
        }
    };
    Carousel.prototype.componentWillUnmount = function () {
        var _a = this.props, touchable = _a.touchable, autoRotate = _a.autoRotate;
        if (touchable) {
            this.track.removeEventListener('touchstart', this.handleTouch);
            this.track.removeEventListener('touchmove', this.handleTouch);
            this.track.removeEventListener('touchend', this.handleTouch);
        }
        if (autoRotate) {
            this.container.removeEventListener('mouseenter', this.pause);
            this.container.removeEventListener('mouseleave', this.resume);
            this.pause();
        }
    };
    Carousel.prototype.setIndex = function (index, event) {
        var currentSlide = this.state.currentSlide;
        var _a = this.props, slideCarousel = _a.slideCarousel, location = _a.location;
        var direction = index > currentSlide ? 'right' : 'left';
        this.setState({ currentSlide: index });
        slideCarousel({
            direction: direction,
            location: location,
            currentIndex: currentSlide,
            nextIndex: index,
            event: event,
        });
    };
    Carousel.prototype.preventScrolling = function (e) {
        var _a = this.state.touches, touchmove = _a.touchmove, touchstart = _a.touchstart;
        var interactions = ['a', 'button'];
        var isInteraction = interactions.includes(e.target.tagName.toLowerCase());
        var movement = Math.abs(touchmove.y - touchstart.y);
        if (!isInteraction && movement > 0) {
            e.preventDefault();
        }
        if (isInteraction && movement > 10) {
            e.preventDefault();
        }
    };
    Carousel.prototype.moveSlide = function (event) {
        var _a = this.props, children = _a.children, slideCarousel = _a.slideCarousel, location = _a.location;
        var _b = this.state, currentSlide = _b.currentSlide, _c = _b.touches, touchstart = _c.touchstart, touchmove = _c.touchmove;
        var slideWidth = document.body.offsetWidth;
        var start = currentSlide * slideWidth;
        var movement = start + (touchstart.x - touchmove.x);
        if (Math.abs(currentSlide * slideWidth - movement) > slideWidth / 6) {
            if (movement > start &&
                currentSlide < __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1) {
                slideCarousel({
                    direction: 'right',
                    location: location,
                    currentIndex: currentSlide,
                    nextIndex: currentSlide + 1,
                    event: event,
                });
                return currentSlide + 1;
            }
            else if (movement < start && currentSlide > 0) {
                slideCarousel({
                    direction: 'left',
                    location: location,
                    currentIndex: currentSlide,
                    nextIndex: currentSlide - 1,
                    event: event,
                });
                return currentSlide - 1;
            }
        }
        return currentSlide;
    };
    Carousel.prototype.calculateSlideWidth = function (children) {
        return {
            width: (__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) > 1
                ? 100 / __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children)
                : 100) + "%",
        };
    };
    Carousel.prototype.formatChildren = function (children) {
        var _this = this;
        var slideStyle = !this.props.dynamicWidth
            ? {}
            : this.calculateSlideWidth(children);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
            var props = {
                isVisible: _this.state.currentSlide === index,
            };
            var slide = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, props);
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { key: index, styleName: "slide", style: slideStyle }, slide));
        });
    };
    Carousel.prototype.isFirst = function () {
        var currentSlide = this.state.currentSlide;
        return currentSlide === 0;
    };
    Carousel.prototype.isLast = function () {
        var currentSlide = this.state.currentSlide;
        var children = this.props.children;
        return currentSlide === __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1;
    };
    Carousel.prototype.transform = function () {
        var _a = this.props, children = _a.children, translationRatio = _a.translationRatio;
        var _b = this.state, currentSlide = _b.currentSlide, _c = _b.touches, touchend = _c.touchend, touchstart = _c.touchstart, touchmove = _c.touchmove;
        if (false) {
            return 'translateX(0%)';
        }
        if (touchend === false && touchstart.x > 0) {
            var movement = touchstart.x - touchmove.x;
            var slideWidth = document.body.offsetWidth;
            var start = currentSlide * slideWidth;
            var limit = slideWidth / 32;
            if (currentSlide === 0 && movement < limit * -1) {
                movement = limit * -1;
            }
            if (currentSlide === __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) - 1) {
                if (movement > limit) {
                    movement = limit * -1;
                }
                if (movement > 0) {
                    movement *= -1;
                }
            }
            var position = translationRatio * Math.abs(start + movement);
            return "translateX(" + position + "px)";
        }
        return "translateX(" + (100 / __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children)) *
            currentSlide *
            translationRatio + "%)";
    };
    Carousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, hideButtons = _a.hideButtons;
        if (!children) {
            return null;
        }
        var _b = this.state, currentSlide = _b.currentSlide, touches = _b.touches;
        var track = {
            width: 100 * __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(children) + "%",
            transform: this.transform(),
            transition: touches.touchend === true ? 'transform .3s ease-out' : 'initial',
        };
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "container", ref: function (c) {
                _this.container = c;
            } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "body" },
                !hideButtons && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "previous" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", onClick: this.handlePrevious, disabled: this.isFirst(), "data-jqa-event-value": "arrow previous" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { styleName: "sr-only" }, "Previous")))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "carousel", ref: function (c) {
                        _this.carousel = c;
                    } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "dots", className: "jg-space-mbn" }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (_, i) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", { key: i },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { styleName: i === currentSlide ? 'dot-active' : 'dot', type: "button", onClick: _this.handleDot(i), "data-jqa-event-value": "carousel dot" },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { styleName: "sr-only" },
                                "Page ",
                                i + 1)))); })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { style: track, ref: function (c) {
                            _this.track = c;
                        } }, this.formatChildren(children))),
                !hideButtons && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "next" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { type: "button", onClick: this.handleNext, disabled: this.isLast(), "data-jqa-event-value": "arrow next" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { styleName: "sr-only" }, "Next")))))));
    };
    Carousel.defaultProps = {
        translationRatio: -1,
        disableVerticalTouchMove: false,
        slideCarousel: function () { },
        hideButtons: false,
        dynamicWidth: false,
    };
    return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
Carousel.defaultProps = {
    translationRatio: -1,
    disableVerticalTouchMove: false,
    slideCarousel: function () { },
    hideButtons: false,
    dynamicWidth: false,
};
/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Carousel, __WEBPACK_IMPORTED_MODULE_2__Carousel_scss___default.a));
var TipCarousel = __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Carousel, __assign({}, __WEBPACK_IMPORTED_MODULE_2__Carousel_scss___default.a, __WEBPACK_IMPORTED_MODULE_3__TipCarousel_scss___default.a), {});
// The below is a temporary measure to facilitate the release of Coach, specifically the funds section. It should be deleted once the full Coach workflow is available.
var PlaceholderCarousel = __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Carousel, __assign({}, __WEBPACK_IMPORTED_MODULE_2__Carousel_scss___default.a, __WEBPACK_IMPORTED_MODULE_4__PlaceholderCarousel_scss___default.a), {});


/***/ }),

/***/ "./src/components/Carousel/PlaceholderCarousel.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1_3jF","slide":"SPxDQ","dots":"ygKd1","dot":"_7sZrH","dot-active":"_1FxKs","navigation":"_22VwR","next":"_3qVTf","previous":"_2PQMq"};

/***/ }),

/***/ "./src/components/Carousel/TipCarousel.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"_2GA8_","slide":"_3Div-","dots":"_163RL","dot":"PM85X","dot-active":"_1ZGNp","navigation":"UACY7","next":"_3cqjl","previous":"_1M3Z7"};

/***/ }),

/***/ "./src/components/DeletePage/DeletePageSuccessAlert.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Alert___ = __webpack_require__("./src/components/Alert/index.tsx");


var DeletePageSuccessAlert = function (_a) {
    var onClose = _a.onClose;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_src_components_Alert___["a" /* default */], { id: "delete_page_success", type: "green", autoCloseMs: 5000, onClose: onClose },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "jg-space-mbn" }, "Your Page has been deleted.")));
};
/* harmony default export */ __webpack_exports__["a"] = (DeletePageSuccessAlert);


/***/ }),

/***/ "./src/components/Funds/ProcessingCosts/ProcessingCostStrings.tsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ProcessingCostStrings = /** @class */ (function (_super) {
    __extends(ProcessingCostStrings, _super);
    function ProcessingCostStrings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProcessingCostStrings.prototype.render = function () {
        var _a = this.props, children = _a.children, targetCurrency = _a.targetCurrency;
        var processingCosts = __WEBPACK_IMPORTED_MODULE_1_config__["PROCESSING_COSTS"][targetCurrency] || __WEBPACK_IMPORTED_MODULE_1_config__["PROCESSING_COSTS"].GBP;
        var fixedCosts = "" + processingCosts.FIXED * 100 + __WEBPACK_IMPORTED_MODULE_2_src_helpers_currencyMap__["c" /* currencyMapToPenny */][targetCurrency];
        var percentageCosts = processingCosts.PERCENTAGE + "%";
        var costs = {
            fixed: fixedCosts,
            percentage: percentageCosts,
            percentageAndFixed: percentageCosts + fixedCosts,
            perDonationBoth: percentageCosts + " + " + fixedCosts + " per donation",
            plusPerDonationFixed: "+ " + fixedCosts + " per donation",
        };
        return children(costs);
    };
    return ProcessingCostStrings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["a"] = (ProcessingCostStrings);


/***/ }),

/***/ "./src/components/Home/Categories.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind__ = __webpack_require__("./node_modules/classnames/bind.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon__ = __webpack_require__("./src/components/Icon/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Categories_less__ = __webpack_require__("./src/components/Home/Categories.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Categories_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Categories_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var cx = __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_6__Categories_less___default.a);
var categories = [
    {
        title: 'Health & medical',
        url: 'https://www.justgiving.com/crowdfunding/categories/health-and-medical',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["h" /* Health */], null),
    },
    {
        title: 'In memory',
        url: 'https://www.justgiving.com/crowdfunding/categories/in-memory',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["i" /* InMemory */], null),
    },
    {
        title: 'Children & youth',
        url: 'https://www.justgiving.com/crowdfunding/categories/children-and-youth',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["c" /* Children */], null),
    },
    {
        title: 'Disability',
        url: 'https://www.justgiving.com/crowdfunding/categories/disability-support',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["d" /* Disability */], null),
    },
    {
        title: 'Local community',
        url: 'https://www.justgiving.com/crowdfunding/categories/local-community',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["l" /* LocalCommunity */], null),
    },
    {
        title: 'Emergencies',
        url: 'https://www.justgiving.com/crowdfunding/categories/emergencies',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["f" /* Emergencies */], null),
    },
    {
        title: 'Animals & pets',
        url: 'https://www.justgiving.com/crowdfunding/categories/animals-and-pets',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["a" /* Animals */], null),
    },
    {
        title: 'Sports',
        url: 'https://www.justgiving.com/crowdfunding/categories/sports',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["o" /* Sports */], null),
    },
    {
        title: 'International aid',
        url: 'https://www.justgiving.com/crowdfunding/categories/international-volunteering',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["j" /* InternationalAid */], null),
    },
    {
        title: 'Education',
        url: 'https://www.justgiving.com/crowdfunding/categories/schools-and-education',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["e" /* Education */], null),
    },
    {
        title: 'Social welfare',
        url: 'https://www.justgiving.com/crowdfunding/categories/social-welfare',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["n" /* SocialWelfare */], null),
    },
    {
        title: 'Art & culture',
        url: 'https://www.justgiving.com/crowdfunding/categories/creative-arts-and-culture',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["b" /* Art */], null),
    },
    {
        title: 'Gardens & environment',
        url: 'https://www.justgiving.com/crowdfunding/categories/gardens-and-environment',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["g" /* Gardens */], null),
    },
    {
        title: 'LGBT+',
        url: 'https://www.justgiving.com/crowdfunding/categories/lgbt',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["k" /* Lgbt */], null),
    },
    {
        title: 'Politics',
        url: 'https://www.justgiving.com/crowdfunding/categories/politics',
        icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon__["m" /* Politics */], null),
    },
];
var Categories = /** @class */ (function (_super) {
    __extends(Categories, _super);
    function Categories(props) {
        var _this = _super.call(this, props) || this;
        _this.showCategories = function () {
            _this.setState({ isVisible: true });
        };
        _this.state = {
            isVisible: false,
        };
        return _this;
    }
    Categories.prototype.render = function () {
        var _a = this.props, loadCategoryPage = _a.loadCategoryPage, getStarted = _a.getStarted;
        var isVisible = this.state.isVisible;
        var listClassName = cx('dna-grid-col-l-8', {
            short: !isVisible,
            list: isVisible,
        });
        var location = 'home > a new way to raise funds';
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-container" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "body", className: "dna-grid-row" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-col-l-4" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", { className: "dna-h1 dna-space-mbm" }, "A new way to raise funds on JustGiving"),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-space-mbm", styleName: "start" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-space-mbm" }, "Raise money for your own personal cause, a person in need, clubs, schools, and communities."),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */], { to: "/create", className: "dna-button dna-button-brand", onClick: function () { return getStarted({ location: location }); } }, "Get started"))),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", { className: listClassName }, categories.map(function (c, i) { return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", { key: i },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", { href: c.url, onClick: function () { return loadCategoryPage({ name: c.title }); } },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { styleName: "icon" }, c.icon),
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { styleName: "title" }, c.title)))); })),
                    !isVisible ? (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { type: "button", className: "dna-button dna-hide-from-l dna-button-ghost", onClick: this.showCategories }, "View all categories")) : null))));
    };
    Categories.propTypes = {
        loadCategoryPage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        getStarted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    };
    return Categories;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(Categories, __WEBPACK_IMPORTED_MODULE_6__Categories_less___default.a));


/***/ }),

/***/ "./src/components/Home/Categories.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1ozxA","body":"_3EEG5","details":"_1-YiE","start":"_1Cw8H","list":"vPr75","icon":"_3gVTk","title":"_3AUQI","short":"_3fvZV vPr75"};

/***/ }),

/***/ "./src/components/Home/Faq.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_collapse__ = __webpack_require__("./node_modules/rc-collapse/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__("./node_modules/lodash/throttle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Faq_less__ = __webpack_require__("./src/components/Home/Faq.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Faq_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Faq_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FaqQuestion__ = __webpack_require__("./src/components/Home/FaqQuestion.js");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var questions = [
    {
        text: 'What can I raise money for?',
        firstParagraph: 'In short, anything that has a positive impact on individuals, communities, and the environment.',
        secondParagraph: 'Most people use JustGiving Crowdfunding to help a friend in need. Not sure if itʼs for you?',
        link: {
            href: 'https://help.justgiving.com/hc/en-us/articles/202895531',
            value: 'Read our guidelines',
        },
    },
    {
        text: 'What happens if I donʼt hit my target?',
        firstParagraph: 'If you donʼt hit your target youʼll still receive any funds you raised (minus some small fees), so you can still make good things happen.',
        secondParagraph: 'Our data shows that pages with targets raise more than those without, so itʼs good to have something to aim for.',
    },
    {
        text: 'Can I change my page duration?',
        firstParagraph: "A shorter time limit keeps up the momentum and that\u02BCs why pages have an initial duration of " + __WEBPACK_IMPORTED_MODULE_5_config___default.a.DEFAULT_PAGE_LIFE + " days.",
        secondParagraph: "Once your page is active you can extend it up to 1 year if you prefer.",
    },
];
var Faq = /** @class */ (function (_super) {
    __extends(Faq, _super);
    function Faq() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isDesktop: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browser__["d" /* isDesktopViewport */])() };
        _this.onResize = function () {
            _this.setState({ isDesktop: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browser__["d" /* isDesktopViewport */])() });
        };
        return _this;
    }
    Faq.renderColumns = function () {
        return questions.map(function (question, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { key: index, styleName: "question" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", { className: "dna-h4" }, question.text),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FaqQuestion__["a" /* default */], { firstParagraph: question.firstParagraph, secondParagraph: question.secondParagraph, link: question.link }))); });
    };
    Faq.renderAccordion = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_rc_collapse__["a" /* default */], { accordion: true, defaultActiveKey: ".$0" }, questions.map(function (question, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_rc_collapse__["a" /* default */].Panel, { key: index, header: question.text },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FaqQuestion__["a" /* default */], { firstParagraph: question.firstParagraph, secondParagraph: question.secondParagraph, link: question.link }))); })));
    };
    Faq.prototype.componentDidMount = function () {
        if (true) {
            this.resizeHandler = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(this.onResize, 60);
            window.addEventListener('resize', this.resizeHandler);
        }
    };
    Faq.prototype.componentWillUnmount = function () {
        if (true) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    };
    Faq.prototype.render = function () {
        var isDesktop = this.state.isDesktop;
        var seeMore = this.props.seeMore;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-grid-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-grid-row", styleName: "body" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "dna-h1", styleName: "title" }, "Frequently asked questions"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "content" }, isDesktop ? Faq.renderColumns() : Faq.renderAccordion()),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "action" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "dna-button dna-button-ghost", target: "_blank", rel: "noreferrer noopener", href: "https://help.justgiving.com/hc/en-us/categories/201602465-Crowdfunding", styleName: "link", onClick: seeMore }, "See more"))))));
    };
    Faq.propTypes = {
        seeMore: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    };
    return Faq;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Faq, __WEBPACK_IMPORTED_MODULE_7__Faq_less___default.a));


/***/ }),

/***/ "./src/components/Home/Faq.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uaDf","body":"rEYSL","title":"_1JAUZ","content":"_1XLoh","question":"_3HRAp","link":"_16IU4","action":"_3ql7Z"};

/***/ }),

/***/ "./src/components/Home/FaqQuestion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FaqQuestion_less__ = __webpack_require__("./src/components/Home/FaqQuestion.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FaqQuestion_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FaqQuestion_less__);




var FaqQuestion = function (_a) {
    var firstParagraph = _a.firstParagraph, secondParagraph = _a.secondParagraph, link = _a.link;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-text-l", styleName: "first-paragraph" }, firstParagraph),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-text-l" }, secondParagraph),
        link && (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-text-l dna-text-normal" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", { target: "_blank", rel: "noreferrer noopener", href: link.href, styleName: "link" }, link.value)))));
};
FaqQuestion.propTypes = {
    firstParagraph: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    secondParagraph: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        href: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    }),
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FaqQuestion, __WEBPACK_IMPORTED_MODULE_3__FaqQuestion_less___default.a));


/***/ }),

/***/ "./src/components/Home/FaqQuestion.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"first-paragraph":"_3G4Q0","link":"_1qzFW"};

/***/ }),

/***/ "./src/components/Home/Featured.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Featured_less__ = __webpack_require__("./src/components/Home/Featured.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Featured_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Featured_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedNow__ = __webpack_require__("./src/components/Home/FeaturedNow.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeaturedCarousel__ = __webpack_require__("./src/components/Home/FeaturedCarousel.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeaturedFilter__ = __webpack_require__("./src/components/Home/FeaturedFilter.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeaturedPages__ = __webpack_require__("./src/components/Home/FeaturedPages.js");








var Featured = function (_a) {
    var carouselPages = _a.carouselPages, filteredPages = _a.filteredPages, filter = _a.filter, isLoading = _a.isLoading, loadMorePages = _a.loadMorePages, changeFilter = _a.changeFilter, activePagesCount = _a.activePagesCount, avatars = _a.avatars, loadAvatars = _a.loadAvatars, selectCard = _a.selectCard, slideCarousel = _a.slideCarousel;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { styleName: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-row", styleName: "body" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FeaturedNow__["a" /* default */], { activePagesCount: activePagesCount }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FeaturedFilter__["a" /* default */], { filter: filter, onChange: changeFilter }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FeaturedCarousel__["a" /* default */], { visible: filter.typeId === 0 && carouselPages.length >= 5, pages: carouselPages, avatars: avatars, loadAvatars: loadAvatars, selectCard: selectCard, slideCarousel: slideCarousel }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FeaturedPages__["a" /* default */], { pages: filteredPages, isLoading: isLoading, filter: filter, loadMore: loadMorePages, avatars: avatars, loadAvatars: loadAvatars, selectCard: selectCard })))));
};
Featured.propTypes = {
    carouselPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            }),
        }),
    }).isRequired).isRequired,
    filteredPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        totalCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        pageNo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                    top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                }),
            }),
        }).isRequired).isRequired,
    }).isRequired,
    filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        categoryId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        typeId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        locationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    }),
    isLoading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    loadMorePages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    changeFilter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    activePagesCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    avatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
    loadAvatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    selectCard: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    slideCarousel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Featured, __WEBPACK_IMPORTED_MODULE_3__Featured_less___default.a));


/***/ }),

/***/ "./src/components/Home/Featured.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2APmc","body":"_3FpwH"};

/***/ }),

/***/ "./src/components/Home/FeaturedCard.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__ = __webpack_require__("./node_modules/@justgiving/dna-card/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg__ = __webpack_require__("./static/images/default-avatar.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeaturedCard_less__ = __webpack_require__("./src/components/Home/FeaturedCard.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeaturedCard_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__FeaturedCard_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









var FeaturedCard = /** @class */ (function (_super) {
    __extends(FeaturedCard, _super);
    function FeaturedCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturedCard.prototype.componentDidMount = function () {
        var _a = this.props, loadAvatars = _a.loadAvatars, page = _a.page;
        if (true && page.items) {
            loadAvatars(page.items.map(function (p) { return p.ownerId; }));
        }
    };
    FeaturedCard.prototype.render = function () {
        var _a = this.props, _b = _a.page, projectId = _b.projectId, projectUrl = _b.projectUrl, projectImage = _b.projectImage, pitch = _b.pitch, progress = _b.progress, numberOfSupporters = _b.numberOfSupporters, amountRaised = _b.amountRaised, owner = _b.owner, ownerId = _b.ownerId, targetCurrency = _b.targetCurrency, projectType = _b.projectType, avatars = _a.avatars, selectCard = _a.selectCard, rank = _a.rank, totalCount = _a.totalCount, intl = _a.intl;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "card-container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__["RelatedStory"], { percentage: progress || 0, title: pitch, owner: owner, numberOfSupporters: numberOfSupporters, totalRaised: intl.formatNumber(amountRaised, { maximumFractionDigits: 0 }) || 0, ownerAvatar: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_image__["h" /* getImageUrlWithTemplate */])(avatars[ownerId], 'CrowdfundingSupporterAvatar') || __WEBPACK_IMPORTED_MODULE_5__static_images_default_avatar_svg___default.a, pageImage: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_image__["h" /* getImageUrlWithTemplate */])(projectImage.url, 'Size800w'), showTotaliser: true, currencySymbol: __WEBPACK_IMPORTED_MODULE_7__helpers_currencyMap__["e" /* default */][targetCurrency] || '£', pageLink: projectUrl, id: projectId, styles: null, onClick: function () {
                    return selectCard({
                        id: projectId,
                        type: projectType,
                        url: projectUrl,
                        rank: rank,
                        totalCount: totalCount,
                    });
                } })));
    };
    FeaturedCard.propTypes = {
        page: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                    top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                }),
            }),
        }).isRequired,
        avatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
        loadAvatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        selectCard: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        rank: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        totalCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        intl: __WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* intlShape */],
    };
    return FeaturedCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FeaturedCard, __WEBPACK_IMPORTED_MODULE_8__FeaturedCard_less___default.a)));


/***/ }),

/***/ "./src/components/Home/FeaturedCard.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card-container":"_3ikbk"};

/***/ }),

/***/ "./src/components/Home/FeaturedCarousel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle__ = __webpack_require__("./node_modules/lodash/throttle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Carousel_Carousel__ = __webpack_require__("./src/components/Carousel/Carousel.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeaturedCard__ = __webpack_require__("./src/components/Home/FeaturedCard.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeaturedCarousel_less__ = __webpack_require__("./src/components/Home/FeaturedCarousel.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeaturedCarousel_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FeaturedCarousel_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var FeaturedCarousel = /** @class */ (function (_super) {
    __extends(FeaturedCarousel, _super);
    function FeaturedCarousel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isDesktop: Object(__WEBPACK_IMPORTED_MODULE_5__helpers_browser__["d" /* isDesktopViewport */])() };
        _this.onResize = function () {
            var isDesktop = _this.state.isDesktop;
            if (isDesktop !== Object(__WEBPACK_IMPORTED_MODULE_5__helpers_browser__["d" /* isDesktopViewport */])()) {
                _this.setState({ isDesktop: !isDesktop });
            }
        };
        return _this;
    }
    FeaturedCarousel.prototype.componentDidMount = function () {
        if (true) {
            this.resizeHandler = __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(this.onResize, 60);
            window.addEventListener('resize', this.resizeHandler);
        }
    };
    FeaturedCarousel.prototype.componentWillUnmount = function () {
        if (true) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    };
    FeaturedCarousel.prototype.render = function () {
        var _a = this.props, visible = _a.visible, pages = _a.pages, avatars = _a.avatars, loadAvatars = _a.loadAvatars, selectCard = _a.selectCard, slideCarousel = _a.slideCarousel;
        var isDesktop = this.state.isDesktop;
        var translationRatio = isDesktop ? -1 : -0.94;
        var transitionStyle = {
            height: visible ? (isDesktop ? 400 : 450) : 0,
            opacity: visible ? 1 : 0,
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "carousel-container", style: transitionStyle },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Carousel_Carousel__["b" /* default */], { touchable: true, translationRatio: translationRatio, styles: __WEBPACK_IMPORTED_MODULE_7__FeaturedCarousel_less___default.a, location: "home > show me", slideCarousel: slideCarousel }, pages.map(function (page, index) { return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FeaturedCard__["a" /* default */], { key: page.projectId, page: page, avatars: avatars, loadAvatars: loadAvatars, selectCard: selectCard, rank: index + 1, totalCount: pages.length })); }))));
    };
    FeaturedCarousel.propTypes = {
        visible: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        pages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                    top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                }),
            }),
        }).isRequired).isRequired,
        avatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
        loadAvatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        selectCard: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        slideCarousel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    };
    FeaturedCarousel.defaultProps = {
        visible: true,
    };
    return FeaturedCarousel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FeaturedCarousel, __WEBPACK_IMPORTED_MODULE_7__FeaturedCarousel_less___default.a));


/***/ }),

/***/ "./src/components/Home/FeaturedCarousel.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"_3r1SV","container":"H2Vno","body":"UXOYM","carousel":"_6clw3","slide":"_14_-a","dots":"_2lfyy","dot":"MWrvF","dot-active":"_2qWfJ MWrvF","navigation":"_13UUO","next":"_23Vt9 _13UUO","previous":"_4IotD _13UUO","sr-only":"UTI64","sr-only-focusable":"_3OKWK"};

/***/ }),

/***/ "./src/components/Home/FeaturedFilter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeaturedFilterBubble__ = __webpack_require__("./src/components/Home/FeaturedFilterBubble.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedFilter_less__ = __webpack_require__("./src/components/Home/FeaturedFilter.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedFilter_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FeaturedFilter_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var CATEGORY_EVERYTHING_ID = 999;
var categories = [
    { id: CATEGORY_EVERYTHING_ID, value: 'Everything' },
    { id: 0, value: 'Animals & pets' },
    { id: 2, value: 'Children & youth' },
    { id: 1, value: 'Creative arts & culture' },
    { id: 5, value: 'Disability support' },
    { id: 13, value: 'Emergencies' },
    { id: 3, value: 'Gardens & environment' },
    { id: 11, value: 'Health & medical' },
    { id: 6, value: 'International volunteering' },
    { id: 9, value: 'Local community' },
    { id: 7, value: 'Schools & education' },
    { id: 8, value: 'Social welfare' },
    { id: 14, value: 'Sports' },
];
var types = [{ id: 0, value: 'Featured' }, { id: 1, value: 'Popular' }];
var locations = [{ id: 0, value: 'Everywhere' }, { id: 1, value: 'Near me' }];
var FeaturedFilter = /** @class */ (function (_super) {
    __extends(FeaturedFilter, _super);
    function FeaturedFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCategoryChanged = function (id) {
            var _a = _this.props, locationId = _a.filter.locationId, onChange = _a.onChange;
            var selection = _this.getSelection(id, 1, locationId);
            onChange(selection);
        };
        _this.handleTypeChanged = function (id) {
            var onChange = _this.props.onChange;
            var selection = _this.getSelection(CATEGORY_EVERYTHING_ID, id, 0);
            onChange(selection);
        };
        _this.handleLocationChanged = function (id) {
            var _a = _this.props, categoryId = _a.filter.categoryId, onChange = _a.onChange;
            var selection = _this.getSelection(categoryId, 1, id);
            onChange(selection);
        };
        return _this;
    }
    FeaturedFilter.prototype.getSelection = function (categoryId, typeId, locationId) {
        var category = categories.find(function (c) { return c.id === categoryId; });
        var type = types.find(function (t) { return t.id === typeId; });
        var location = locations.find(function (l) { return l.id === locationId; });
        return { category: category, type: type, location: location };
    };
    FeaturedFilter.prototype.render = function () {
        var _a = this.props.filter, categoryId = _a.categoryId, typeId = _a.typeId, locationId = _a.locationId;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "dna-h1" }, "Show me "),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeaturedFilterBubble__["a" /* default */], { title: "Category", options: categories, selectedId: categoryId, onSelectionChanged: this.handleCategoryChanged }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "dna-h1" }, "that\u02BCs "),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeaturedFilterBubble__["a" /* default */], { title: "Type", options: types, selectedId: typeId, onSelectionChanged: this.handleTypeChanged }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeaturedFilterBubble__["a" /* default */], { title: "Location", options: locations, selectedId: locationId, onSelectionChanged: this.handleLocationChanged })));
    };
    FeaturedFilter.propTypes = {
        filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            categoryId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            typeId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            locationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        }),
        onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    };
    return FeaturedFilter;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FeaturedFilter, __WEBPACK_IMPORTED_MODULE_4__FeaturedFilter_less___default.a));


/***/ }),

/***/ "./src/components/Home/FeaturedFilter.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Ds98"};

/***/ }),

/***/ "./src/components/Home/FeaturedFilterBubble.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("./node_modules/classnames/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_chunk__ = __webpack_require__("./node_modules/lodash/chunk.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Modal__ = __webpack_require__("./src/components/Modal/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeaturedFilterBubble_less__ = __webpack_require__("./src/components/Home/FeaturedFilterBubble.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeaturedFilterBubble_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FeaturedFilterBubble_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MAX_OPTIONS_PER_COLUMN = 7;
var FeaturedFilterBubble = /** @class */ (function (_super) {
    __extends(FeaturedFilterBubble, _super);
    function FeaturedFilterBubble() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isOpen: false };
        _this.handleOptionSelected = function (option) {
            var onSelectionChanged = _this.props.onSelectionChanged;
            if (Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browser__["d" /* isDesktopViewport */])()) {
                _this.trigger.addEventListener('transitionend', _this.handleTransitionEnd);
                var before = _this.trigger.offsetWidth;
                _this.trigger.style.width = 'auto';
                _this.trigger.innerText = option.value;
                var after_1 = _this.trigger.offsetWidth;
                _this.trigger.style.width = before + "px";
                setTimeout(function () {
                    _this.trigger.style.width = after_1 + "px";
                }, 1);
            }
            _this.setState({ isOpen: false });
            return onSelectionChanged && onSelectionChanged(option.id);
        };
        _this.handleTriggerClick = function () {
            _this.setState({ isOpen: !_this.state.isOpen });
        };
        _this.handleTransitionEnd = function () {
            _this.trigger.style.width = 'auto';
            _this.trigger.removeEventListener('transitionend', _this.handleTransitionEnd);
        };
        _this.handleClose = function (e) {
            if (e.target === _this.close ||
                (Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browser__["d" /* isDesktopViewport */])() && e.target !== _this.trigger)) {
                _this.setState({ isOpen: false });
            }
        };
        return _this;
    }
    FeaturedFilterBubble.prototype.componentDidMount = function () {
        window.document.addEventListener('click', this.handleClose);
    };
    FeaturedFilterBubble.prototype.componentWillUnmount = function () {
        window.document.removeEventListener('click', this.handleClose);
    };
    FeaturedFilterBubble.prototype.getSelectedOption = function () {
        var _a = this.props, options = _a.options, selectedId = _a.selectedId;
        return options.filter(function (o) { return o.id === selectedId; })[0] || options[0];
    };
    FeaturedFilterBubble.prototype.composeStyle = function (styleName) {
        return "" + styleName + (this.state.isOpen ? '-open' : '');
    };
    FeaturedFilterBubble.prototype.renderOptions = function (options) {
        var _this = this;
        return options.map(function (option, index) {
            var buttonClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('dna-text-l', 'dna-text-normal', {
                'dna-text-brand': option === _this.getSelectedOption(),
            });
            return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { key: index, className: buttonClass, styleName: "option", onClick: function () { return _this.handleOptionSelected(option); } }, option.value));
        });
    };
    FeaturedFilterBubble.prototype.renderModal = function () {
        var _this = this;
        var _a = this.props, title = _a.title, options = _a.options;
        var isOpen = this.state.isOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_src_components_Modal__["a" /* default */], { isOpen: isOpen, shouldCloseOnOverlayClick: false, maintainPosition: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "modal-container" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("header", null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2", { className: "dna-h2", styleName: "modal-title" }, title),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { styleName: "close", ref: function (c) {
                            _this.close = c;
                        }, onClick: this.handleClose }, "Close")),
                this.renderOptions(options))));
    };
    FeaturedFilterBubble.prototype.renderBubble = function () {
        var _this = this;
        var options = this.props.options;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "bubble-container" }, __WEBPACK_IMPORTED_MODULE_4_lodash_chunk___default()(options, MAX_OPTIONS_PER_COLUMN).map(function (column, i) { return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { key: i, styleName: "bubble-option-container" }, _this.renderOptions(column))); })));
    };
    FeaturedFilterBubble.prototype.render = function () {
        var _this = this;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: this.composeStyle('bubble') },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { className: "dna-h1 dna-text-brand", styleName: this.composeStyle('trigger'), ref: function (c) {
                    _this.trigger = c;
                }, onClick: this.handleTriggerClick }, this.getSelectedOption().value),
            Object(__WEBPACK_IMPORTED_MODULE_6__helpers_browser__["d" /* isDesktopViewport */])() ? this.renderBubble() : this.renderModal()));
    };
    FeaturedFilterBubble.propTypes = {
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        })).isRequired,
        selectedId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
        onSelectionChanged: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    };
    return FeaturedFilterBubble;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(FeaturedFilterBubble, __WEBPACK_IMPORTED_MODULE_7__FeaturedFilterBubble_less___default.a));


/***/ }),

/***/ "./src/components/Home/FeaturedFilterBubble.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bubble":"_2BdUb","bubble-open":"_2NEBB","bubble-container":"_5DIwP","trigger":"_2weSm","trigger-open":"_3dWqx","bubble-option-container":"_2vpI9","option":"_2vqjA","modal-container":"_3v4md","modal-title":"zY-8u","close":"_2A5a_"};

/***/ }),

/***/ "./src/components/Home/FeaturedNow.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedNow_less__ = __webpack_require__("./src/components/Home/FeaturedNow.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FeaturedNow_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__FeaturedNow_less__);





var FeaturedNow = function (_a) {
    var activePagesCount = _a.activePagesCount, intl = _a.intl;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "container" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-text-xl" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "dna-text-normal" },
                intl.formatNumber(activePagesCount),
                ' '),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "people raising funds now"))));
};
FeaturedNow.propTypes = {
    activePagesCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    intl: __WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* intlShape */],
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["d" /* injectIntl */])(__WEBPACK_IMPORTED_MODULE_3_react_css_modules___default()(FeaturedNow, __WEBPACK_IMPORTED_MODULE_4__FeaturedNow_less___default.a)));


/***/ }),

/***/ "./src/components/Home/FeaturedNow.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1mX5w"};

/***/ }),

/***/ "./src/components/Home/FeaturedPages.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("./node_modules/react-intl/lib/index.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__ = __webpack_require__("./node_modules/@justgiving/dna-card/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference__ = __webpack_require__("./node_modules/lodash/difference.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_LoadingButton___ = __webpack_require__("./src/components/LoadingButton/index.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_default_avatar_svg__ = __webpack_require__("./static/images/default-avatar.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_images_default_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_images_default_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_image__ = __webpack_require__("./src/helpers/image.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_browser__ = __webpack_require__("./src/helpers/browser.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_currencyMap__ = __webpack_require__("./src/helpers/currencyMap.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeaturedPages_less__ = __webpack_require__("./src/components/Home/FeaturedPages.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeaturedPages_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__FeaturedPages_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












var FeaturedPages = /** @class */ (function (_super) {
    __extends(FeaturedPages, _super);
    function FeaturedPages(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLoadMore = function () {
            var _a = _this.props, _b = _a.pages, items = _b.items, pageNo = _b.pageNo, totalCount = _b.totalCount, _c = _a.filter, categoryId = _c.categoryId, locationId = _c.locationId, loadMore = _a.loadMore;
            var _d = _this.state, actualPageSize = _d.actualPageSize, actualPageNo = _d.actualPageNo;
            var nextPageNo = actualPageNo + 1;
            var nextPageOffset = Math.min(totalCount, actualPageSize * nextPageNo);
            if (items.length < totalCount && items.length < nextPageOffset) {
                loadMore({ pageNo: pageNo + 1, categoryId: categoryId, locationId: locationId });
            }
            _this.setState({
                actualPageNo: nextPageNo,
                pageOffset: nextPageOffset,
            });
        };
        _this.state = FeaturedPages.getInitialState();
        return _this;
    }
    FeaturedPages.getInitialState = function () {
        var actualPageSize = Object(__WEBPACK_IMPORTED_MODULE_9__helpers_browser__["d" /* isDesktopViewport */])() ? 6 : 4;
        return {
            actualPageNo: 1,
            actualPageSize: actualPageSize,
            pageOffset: actualPageSize,
        };
    };
    FeaturedPages.prototype.componentDidMount = function () {
        var _a = this.props, pages = _a.pages, loadAvatars = _a.loadAvatars;
        if (true && pages.items) {
            loadAvatars(pages.items.map(function (p) { return p.ownerId; }));
        }
    };
    FeaturedPages.prototype.componentWillReceiveProps = function (nextProps) {
        var _a = this.props, items = _a.pages.items, filter = _a.filter, loadAvatars = _a.loadAvatars;
        if (true) {
            var owners = items.map(function (p) { return p.ownerId; });
            var nextOwners = nextProps.pages.items.map(function (p) { return p.ownerId; });
            var ownersDelta = __WEBPACK_IMPORTED_MODULE_5_lodash_difference___default()(owners, nextOwners);
            if (ownersDelta.length) {
                loadAvatars(ownersDelta);
            }
            if (filter !== nextProps.filter) {
                this.state = FeaturedPages.getInitialState();
            }
        }
    };
    FeaturedPages.prototype.renderLoadMoreButton = function () {
        var _a = this.props, totalCount = _a.pages.totalCount, isLoading = _a.isLoading;
        var pageOffset = this.state.pageOffset;
        if (pageOffset < totalCount) {
            return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "action" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_src_components_LoadingButton___["a" /* default */], { loading: isLoading, onClick: this.handleLoadMore, color: "purple", className: 'jg-btn--ghost', value: "See more" })));
        }
        return null;
    };
    FeaturedPages.prototype.render = function () {
        var _a = this.props, _b = _a.pages, items = _b.items, totalCount = _b.totalCount, avatars = _a.avatars, selectCard = _a.selectCard, intl = _a.intl;
        var pageOffset = this.state.pageOffset;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "page-cards" }, items.slice(0, pageOffset).map(function (page, i) {
                var progress = page.progress, pitch = page.pitch, owner = page.owner, numberOfSupporters = page.numberOfSupporters, amountRaised = page.amountRaised, ownerId = page.ownerId, projectImage = page.projectImage, projectUrl = page.projectUrl, projectId = page.projectId, targetCurrency = page.targetCurrency, projectType = page.projectType;
                return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "card", key: projectId },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__justgiving_dna_card__["RelatedStory"], { percentage: progress || 0, title: pitch, owner: owner, numberOfSupporters: numberOfSupporters, totalRaised: intl.formatNumber(amountRaised, {
                            maximumFractionDigits: 0,
                        }) || 0, ownerAvatar: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_image__["h" /* getImageUrlWithTemplate */])(avatars[ownerId], 'CrowdfundingSupporterAvatar') || __WEBPACK_IMPORTED_MODULE_7__static_images_default_avatar_svg___default.a, pageImage: Object(__WEBPACK_IMPORTED_MODULE_8__helpers_image__["h" /* getImageUrlWithTemplate */])(projectImage.url, 'Size400w'), showTotaliser: true, currencySymbol: __WEBPACK_IMPORTED_MODULE_10__helpers_currencyMap__["e" /* default */][targetCurrency] || '£', pageLink: projectUrl, id: projectId, styles: null, onClick: function () {
                            return selectCard({
                                id: projectId,
                                type: projectType,
                                url: projectUrl,
                                rank: i + 1,
                                totalCount: totalCount,
                            });
                        } })));
            })),
            this.renderLoadMoreButton()));
    };
    FeaturedPages.propTypes = {
        pages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            totalCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            pageNo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
                progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
                pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
                projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
                projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                    url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                        top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                        left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                        width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                        height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    }),
                }),
            }).isRequired).isRequired,
        }).isRequired,
        isLoading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
        filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            categoryId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            typeId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            locationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        }),
        loadMore: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        avatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
        loadAvatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        selectCard: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
        intl: __WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* intlShape */],
    };
    FeaturedPages.defaultProps = {
        pageNo: 1,
    };
    return FeaturedPages;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(FeaturedPages, __WEBPACK_IMPORTED_MODULE_11__FeaturedPages_less___default.a)));


/***/ }),

/***/ "./src/components/Home/FeaturedPages.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"page-cards":"_1q5PL","card":"_22VOu","action":"_2R3-6"};

/***/ }),

/***/ "./src/components/Home/Fees.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Funds_ProcessingCosts_ProcessingCostStrings__ = __webpack_require__("./src/components/Funds/ProcessingCosts/ProcessingCostStrings.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fees_less__ = __webpack_require__("./src/components/Home/Fees.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Fees_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Fees_less__);




var Fees = function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section", { styleName: "container" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-grid-container" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "dna-grid-row", styleName: "body" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1", { className: "dna-h1", styleName: "title" }, "Easy, secure, affordable"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "dna-text-xl" },
                "Join ",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "dna-text-normal" }, "500,000+"),
                " people raising money for personal causes on JustGiving"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { styleName: "benefits" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "checklist" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "dna-text-xl dna-text-normal", styleName: "checklist__item" }, "Raise money with the world's most trusted fundraising website")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "dna-text-xl dna-text-normal", styleName: "checklist__item" }, "No platform fee - keep more of what you raise!")),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "dna-text-xl dna-text-normal", styleName: "checklist__item" }, "Withdraw what you've raised to your bank account"))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", { styleName: "list" },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Funds_ProcessingCosts_ProcessingCostStrings__["a" /* default */], { targetCurrency: "GBP" }, function (_a) {
                            var perDonationBoth = _a.perDonationBoth;
                            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { className: "dna-text-xl" },
                                "* Standard processing costs apply (",
                                perDonationBoth,
                                ")"));
                        })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", { className: "dna-text-xl dna-text-normal", target: "_blank", rel: "noreferrer noopener", href: " https://help.justgiving.com/hc/en-us/articles/203067602-Crowdfunding-Fees", styleName: "link" }, "Read more about our fees"))))))))); };
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_css_modules___default()(Fees, __WEBPACK_IMPORTED_MODULE_3__Fees_less___default.a));


/***/ }),

/***/ "./src/components/Home/Fees.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Vx4X","body":"_2Wn0J","title":"rzygy","benefits":"_3tVzm","list":"_3SJcu","checklist":"_3mF8y _3SJcu","checklist__item":"_14mtH","link":"_1yV7x","calculator":"_11UzW","calculator-link":"_1XQud _1yV7x"};

/***/ }),

/***/ "./src/components/Home/GetStarted.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetStarted_less__ = __webpack_require__("./src/components/Home/GetStarted.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetStarted_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GetStarted_less__);





var location = 'home > your story starts here';
var GetStarted = function (_a) {
    var getStarted = _a.getStarted;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { styleName: "get-started" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "overlay" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "content" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "header", className: "dna-h1" }, "Your story starts here"),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "sub-header", className: "dna-text-xl" }, "Raise money for good"),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "button-container" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { styleName: "button", className: "dna-button dna-button-brand", to: "/create", onClick: function () { return getStarted({ location: location }); } }, "Get started"))))));
};
GetStarted.propTypes = {
    getStarted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(GetStarted, __WEBPACK_IMPORTED_MODULE_4__GetStarted_less___default.a, {
    allowMultiple: true,
}));


/***/ }),

/***/ "./src/components/Home/GetStarted.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"get-started":"_2_WqM","overlay":"BIXZ2","content":"_1Z4Q6","header":"_1wO2L","sub-header":"Lj9xE","button-container":"tJnYc","button":"UNnTN"};

/***/ }),

/***/ "./src/components/Home/Hero.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__("./config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_less__ = __webpack_require__("./src/components/Home/Hero.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Hero_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Hero = /** @class */ (function (_super) {
    __extends(Hero, _super);
    function Hero() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // This is used to enable entities for design to stop hanging fragments on statement lines
    Hero.createStatement = function (statement) {
        return { __html: statement };
    };
    Hero.prototype.componentDidMount = function () {
        var _this = this;
        var isVisible = this.props.isVisible;
        if (isVisible) {
            setImmediate(function () {
                _this.active.classList.add('show');
            });
        }
    };
    Hero.prototype.componentWillReceiveProps = function (nextProps) {
        var isVisible = this.props.isVisible;
        if (isVisible !== nextProps.isVisible) {
            if (nextProps.isVisible) {
                this.active.classList.add('show');
            }
            else {
                this.active.classList.remove('show');
            }
        }
    };
    Hero.prototype.componentWillUnmount = function () {
        clearTimeout(this.next);
    };
    Hero.prototype.render = function () {
        var _this = this;
        var _a = this.props, image = _a.image, statement = _a.statement, pageName = _a.pageName;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: image },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", { styleName: "brand", className: "jg-space-mbn" }, "JustGiving Crowdfunding"),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "active", ref: function (c) {
                    _this.active = c;
                } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { styleName: "statement", className: "jg-space-mbn", dangerouslySetInnerHTML: Hero.createStatement(statement) }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { styleName: "action", className: "jg-space-mbn" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", { href: __WEBPACK_IMPORTED_MODULE_3_config___default.a.CROWDFUNDING_BASE_URI + "/" + pageName, className: "dna-button dna-button-ghost" }, "Read our story")))));
    };
    Hero.propTypes = {
        isVisible: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        statement: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        pageName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    };
    return Hero;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Hero, __WEBPACK_IMPORTED_MODULE_4__Hero_less___default.a));

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./src/components/Home/Hero.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_38AT_","body":"_3HxEt","carousel":"_1W-89","slide":"_2Qs5C","dots":"_1cCeF","dot":"_1O0Ez","dot-active":"tGWOs _1O0Ez","navigation":"_1O-Bh","next":"oib54 _1O-Bh","previous":"_1qAog _1O-Bh","sr-only":"r5HXU","sr-only-focusable":"OdPve","hero":"_1UGeW","family":"_24IuK _1UGeW","ollie":"_1oWbI _1UGeW","film":"JOM-i _1UGeW","lola":"fwgjy _1UGeW","derry":"_17U3O _1UGeW","brand":"_10EwY","active":"_1zVeQ","statement":"_38slX","action":"_3HJ5D"};

/***/ }),

/***/ "./src/components/Home/Heroes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Carousel_Carousel__ = __webpack_require__("./src/components/Carousel/Carousel.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Transitions__ = __webpack_require__("./src/components/Transitions/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hero__ = __webpack_require__("./src/components/Home/Hero.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Hero_less__ = __webpack_require__("./src/components/Home/Hero.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Hero_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Hero_less__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var heroes = [
    {
        statement: 'We raised £16,550 to reunite a&nbsp;family',
        pageName: 'sharon-croy',
        image: 'family',
    },
    {
        statement: 'We raised £13,114 for&nbsp;Ollie',
        pageName: 'peteandjane-gardiner',
        image: 'ollie',
    },
    {
        statement: 'We raised £1,600 to produce our&nbsp;film',
        pageName: 'barefiilm',
        image: 'film',
    },
    {
        statement: 'We raised £1,425 for vet&nbsp;bills',
        pageName: 'lolaslegs',
        image: 'lola',
    },
    {
        statement: 'We raised £2,505 for&nbsp;Derry',
        pageName: 'adam-johnson',
        image: 'derry',
    },
];
var Heroes = function (_a) {
    var slideCarousel = _a.slideCarousel;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_src_components_Transitions__["a" /* RevealTransition */], { active: true, delay: "0.5s", duration: "1s" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_src_components_Carousel_Carousel__["b" /* default */], { touchable: true, disableVerticalTouchMove: true, autoRotate: 5000, styles: __WEBPACK_IMPORTED_MODULE_5__Hero_less___default.a, location: "home > hero", slideCarousel: slideCarousel }, heroes.map(function (hero, i) { return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Hero__["a" /* default */], __assign({ key: i }, hero))); }))));
};
Heroes.propTypes = {
    slideCarousel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
};
/* harmony default export */ __webpack_exports__["a"] = (Heroes);


/***/ }),

/***/ "./src/components/Home/Home.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_less__ = __webpack_require__("./src/components/Home/Home.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Home_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Home_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Categories__ = __webpack_require__("./src/components/Home/Categories.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Featured__ = __webpack_require__("./src/components/Home/Featured.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fees__ = __webpack_require__("./src/components/Home/Fees.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GetStarted__ = __webpack_require__("./src/components/Home/GetStarted.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Faq__ = __webpack_require__("./src/components/Home/Faq.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Heroes__ = __webpack_require__("./src/components/Home/Heroes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Testimonials__ = __webpack_require__("./src/components/Home/Testimonials.js");











var Home = function (_a) {
    var carouselPages = _a.carouselPages, filteredPages = _a.filteredPages, filter = _a.filter, isLoading = _a.isLoading, loadFilteredPages = _a.loadFilteredPages, changePagesFilter = _a.changePagesFilter, activePagesCount = _a.activePagesCount, avatars = _a.avatars, loadAvatars = _a.loadAvatars, loadCategoryPage = _a.loadCategoryPage, getStarted = _a.getStarted, seeMoreFaq = _a.seeMoreFaq, selectCard = _a.selectCard, slideCarousel = _a.slideCarousel;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Heroes__["a" /* default */], { slideCarousel: slideCarousel }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Categories__["a" /* default */], { loadCategoryPage: loadCategoryPage, getStarted: getStarted }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Featured__["a" /* default */], { carouselPages: carouselPages, filteredPages: filteredPages, filter: filter, isLoading: isLoading, loadMorePages: loadFilteredPages, changeFilter: changePagesFilter, activePagesCount: activePagesCount, loadAvatars: loadAvatars, avatars: avatars, selectCard: selectCard, slideCarousel: slideCarousel }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Testimonials__["a" /* default */], { getStarted: getStarted }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Fees__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GetStarted__["a" /* default */], { getStarted: getStarted }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Faq__["a" /* default */], { seeMore: seeMoreFaq })));
};
Home.propTypes = {
    carouselPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
            width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
            }),
        }),
    }).isRequired).isRequired,
    filteredPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        totalCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        pageNo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        items: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
            projectType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            progress: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            pitch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            owner: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            numberOfSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
            projectId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
            projectImage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                url: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
                width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                cropArea: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
                    top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                    height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
                }),
            }),
        }).isRequired).isRequired,
    }).isRequired,
    filter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
        categoryId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        typeId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        locationId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    }),
    isLoading: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    loadFilteredPages: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    changePagesFilter: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    activePagesCount: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    avatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
    loadAvatars: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    loadCategoryPage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    getStarted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    seeMoreFaq: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    selectCard: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    slideCarousel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Home, __WEBPACK_IMPORTED_MODULE_3__Home_less___default.a, {
    allowMultiple: true,
}));


/***/ }),

/***/ "./src/components/Home/Home.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/components/Home/Testimonial.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_formatter__ = __webpack_require__("./src/helpers/formatter.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Testimonial_less__ = __webpack_require__("./src/components/Home/Testimonial.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Testimonial_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Testimonial_less__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var Testimonial = /** @class */ (function (_super) {
    __extends(Testimonial, _super);
    function Testimonial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Testimonial.prototype.renderBubble = function () {
        var _a = this.props, direction = _a.direction, quote = _a.quote, name = _a.name, amountRaised = _a.amountRaised, targetCurrency = _a.targetCurrency, totalCountSupporters = _a.totalCountSupporters;
        var formattedAmount = Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_formatter__["b" /* formatCurrency */])(amountRaised, {
            currency: targetCurrency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "speech-bubble-" + direction },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-text-l", styleName: "quote" },
                "\"",
                quote,
                "\""),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-text-default-regular", styleName: "name" }, name),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-show-block-from-l dna-text-l" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, "Raised "),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "dna-text-brand-m" }, formattedAmount),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", null, " with "),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: "dna-h5" },
                    totalCountSupporters,
                    " supporter",
                    totalCountSupporters !== 1 ? 's' : ''))));
    };
    Testimonial.prototype.renderAvatar = function () {
        var _a = this.props, image = _a.image, name = _a.name;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "avatar-container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "avatar", style: { backgroundImage: "url(" + image + ")" }, alt: name + " profile image" })));
    };
    Testimonial.prototype.renderReverseAvatar = function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "avatar-reverse-display" }, this.renderAvatar());
    };
    Testimonial.prototype.render = function () {
        var direction = this.props.direction;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "container-" + direction },
            direction === 'left' && this.renderAvatar(),
            this.renderBubble(),
            direction === 'right' && this.renderReverseAvatar()));
    };
    Testimonial.propTypes = {
        direction: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['right', 'left']).isRequired,
        image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        name: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        amountRaised: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
        targetCurrency: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
        totalCountSupporters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    };
    return Testimonial;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Testimonial, __WEBPACK_IMPORTED_MODULE_4__Testimonial_less___default.a));


/***/ }),

/***/ "./src/components/Home/Testimonial.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2xCpb","container-left":"_4X-fs","container-right":"_1U1pg","speech-bubble-left":"_177es","speech-bubble-right":"_3EQrS","avatar-reverse-display":"_23glO","avatar-container":"_1256t","avatar":"_2sOzQ","quote":"_3lsSX","name":"_3xtPa"};

/***/ }),

/***/ "./src/components/Home/Testimonials.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules__ = __webpack_require__("./node_modules/react-css-modules/dist/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__("./node_modules/react-router-dom/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_waypoint__ = __webpack_require__("./node_modules/react-waypoint/cjs/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_waypoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Transitions__ = __webpack_require__("./src/components/Transitions/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Testimonials_less__ = __webpack_require__("./src/components/Home/Testimonials.less");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Testimonials_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Testimonials_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Testimonial__ = __webpack_require__("./src/components/Home/Testimonial.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_avatar_little_svg__ = __webpack_require__("./src/components/Home/images/avatar-little.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_avatar_little_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_avatar_little_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_avatar_sharon_svg__ = __webpack_require__("./src/components/Home/images/avatar-sharon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_avatar_sharon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_avatar_sharon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_avatar_morris_svg__ = __webpack_require__("./src/components/Home/images/avatar-morris.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_avatar_morris_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_avatar_morris_svg__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();











var testimonials = [
    {
        image: __WEBPACK_IMPORTED_MODULE_8__images_avatar_little_svg___default.a,
        quote: 'My involvement with JustGiving has been an all-round wonderful experience! Very grateful for its existence.',
        name: 'R Little',
        amountRaised: 4355,
        totalCountSupporters: 45,
    },
    {
        image: __WEBPACK_IMPORTED_MODULE_9__images_avatar_sharon_svg___default.a,
        quote: "Thank you JustGiving, without you I wouldn't have been able to help my friend.",
        name: 'Sharon Croy',
        amountRaised: 16550,
        totalCountSupporters: 463,
    },
    {
        image: __WEBPACK_IMPORTED_MODULE_10__images_avatar_morris_svg___default.a,
        quote: 'What an amazing site! I raised my target in the space of 3 hours!!',
        name: 'Ash Morris',
        amountRaised: 1600,
        totalCountSupporters: 22,
    },
];
var Testimonials = /** @class */ (function (_super) {
    __extends(Testimonials, _super);
    function Testimonials() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { animate: false };
        _this.onEnter = function () {
            _this.setState({ animate: true });
        };
        return _this;
    }
    Testimonials.getAnimationDetails = function (index) {
        return {
            direction: index % 2 === 0 ? 'left' : 'right',
            startOffset: index % 2 === 0 ? -60 : 60,
            transitionDelay: index * 200 + 200 + "ms",
        };
    };
    Testimonials.prototype.render = function () {
        var _this = this;
        var getStarted = this.props.getStarted;
        var location = 'home > success stories';
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "container" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_waypoint___default.a, { onEnter: this.onEnter }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-container" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "dna-grid-row", styleName: "body" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1", { className: "dna-h1", styleName: "title" }, "Success stories"),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "dna-text-xl", styleName: "subtitle" }, "People like you are making good things happen on JustGiving every day!"),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "content" }, testimonials.map(function (testimonial, index) {
                        var animation = Testimonials.getAnimationDetails(index);
                        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Transitions__["b" /* TranslateXTransition */], { key: index, active: _this.state.animate, startOffset: animation.startOffset, duration: "0.5s", timingFunction: "ease-in-out", delay: animation.transitionDelay },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Transitions__["a" /* RevealTransition */], { active: _this.state.animate, delay: "0.5s", duration: "1s" },
                                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Testimonial__["a" /* default */], { direction: animation.direction, image: testimonial.image, quote: testimonial.quote, name: testimonial.name, amountRaised: testimonial.amountRaised, targetCurrency: "GBP", totalCountSupporters: testimonial.totalCountSupporters }))));
                    })),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { styleName: "action" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */], { className: "dna-button dna-button-ghost-clear", to: "/create", onClick: function () { return getStarted({ location: location }); } }, "Get started")))),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_waypoint___default.a, { onEnter: this.onEnter })));
    };
    Testimonials.propTypes = {
        getStarted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    };
    return Testimonials;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_css_modules___default()(Testimonials, __WEBPACK_IMPORTED_MODULE_6__Testimonials_less___default.a));


/***/ }),

/***/ "./src/components/Home/Testimonials.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"IkkOq","body":"_2SX3-","title":"UIJh0","subtitle":"IRsDL","content":"_2tm-n","action":"fnCPu"};

/***/ }),

/***/ "./src/components/Home/images/avatar-little.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "18bcf93f900a87ac51313a0855536261.svg";

/***/ }),

/***/ "./src/components/Home/images/avatar-morris.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ac174d9ed288bd973da4e08335177784.svg";

/***/ }),

/***/ "./src/components/Home/images/avatar-sharon.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cebe8b2c261a05ba9b6732bb3ae9843b.svg";

/***/ }),

/***/ "./src/components/Icon/Animals.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Animals = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "37", height: "35", viewBox: "43 0 37 35" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M61.43 18.03c5.18 0 9.4 4.93 9.4 10.98 0 1.7-.32 2.1-.32 2.1s0 .03-.2.03c-.6 0-1.6-.32-2.7-.66-1.7-.54-3.8-1.2-6.1-1.2s-4.45.66-6.16 1.2c-1.07.34-2.1.66-2.7.66-.16 0-.22-.05-.22-.05 0-.02-.32-.37-.32-2 0-6.06 4.22-11 9.4-11m-12.54 11c0 1.67.25 2.85.8 3.7.45.67 1.3 1.47 2.9 1.47 1.1 0 2.25-.4 3.6-.8 1.6-.5 3.4-1.08 5.24-1.08 1.84 0 3.64.56 5.22 1.06 1.35.43 2.53.8 3.62.8 2.43 0 3.7-1.74 3.7-5.2 0-7.77-5.66-14.1-12.57-14.1-6.92 0-12.55 6.33-12.55 14.1zM55.3 3.6h.1c.8 0 1.9 1.26 2.18 3.1.16 1 .05 1.97-.3 2.7-.12.24-.45.83-.95.9h-.1c-.8 0-1.9-1.26-2.18-3.1-.3-1.9.44-3.5 1.26-3.63zm.9 9.9c.2 0 .4-.03.6-.06 1.4-.22 2.6-1.2 3.3-2.68.62-1.3.83-2.92.58-4.54C60.2 2.87 58 .44 55.45.44c-.2 0-.4 0-.58.04-2.74.42-4.44 3.6-3.9 7.22.52 3.34 2.73 5.77 5.28 5.77zm9.18-6.8c.3-1.84 1.38-3.1 2.18-3.1h.1c.83.1 1.56 1.73 1.27 3.63-.28 1.85-1.37 3.1-2.17 3.1h-.1c-.5-.06-.84-.65-.96-.9-.34-.74-.45-1.73-.3-2.72zm.8 6.74c.2.03.4.04.58.04 2.55 0 4.76-2.43 5.27-5.78.55-3.65-1.15-6.8-3.9-7.24-.18-.03-.37-.04-.57-.04C65 .42 62.8 2.85 62.3 6.2c-.24 1.63-.03 3.24.6 4.55.7 1.5 1.9 2.46 3.3 2.68zm9.7 1.15c-.44.8-1.03 1.1-1.27 1.1-.1-.16-.2-.85.3-1.67.44-.8 1.05-1.13 1.25-1.15.13.1.24.85-.2 1.7zm1.72-4.5c-.44-.25-.94-.37-1.46-.37-1.55 0-3.13 1.1-4.04 2.8-.55 1.02-.8 2.15-.68 3.18.12 1.25.75 2.25 1.7 2.77.46.22.96.35 1.48.35 1.55 0 3.14-1.1 4.04-2.8 1.26-2.35.8-4.96-1.03-5.94zm-30.73 2.8c.23 0 .84.35 1.27 1.15.46.86.35 1.7.28 1.7-.24 0-.85-.36-1.28-1.16-.45-.87-.34-1.6-.26-1.7zm1.54 5.95c.6 0 1.1-.13 1.5-.37 1-.6 1.6-1.6 1.7-2.8.1-1.07-.1-2.2-.7-3.2-.9-1.7-2.5-2.8-4-2.8-.5 0-1 .1-1.44.35-1.84 1-2.3 3.6-1.04 5.94.9 1.7 2.5 2.8 4.04 2.8" })));
};
Animals.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Animals.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Animals);


/***/ }),

/***/ "./src/components/Icon/Art.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Art = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "38", height: "38", viewBox: "32 0 38 38" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { fill: color, fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M65.35 23.24c-.12 1.98-1.5 3.96-2.5 5.28-2.18 2.8-5.47 4.48-9.27 4.73-3.57.24-7.2-.8-10.3-2.96 1.37-1.2 2.95-2.6 4.8-4.3 4.53-4.1 9.04-8.3 11.1-10.2.86 1.8 2.15 2.7 4.27 3.8 1.23.6 2.03 1.5 1.9 3.5M38.55 9.7c4.6-5.95 12.32-6.37 16.83-3.35.64.42 1.13.98 1.52 1.73-.83.13-1.6.5-2.2 1.1-.02.04-.07.1-.13.15-.26-.38-.57-.7-.94-1-.75-.6-1.68-.9-2.62-.9-1.2 0-2.3.54-3.1 1.48-.6.9-.9 2-.7 3.1.2 1.1.8 2 1.6 2.7.2.2.4.3.6.4l-5.7 6.3c-.8 0-1.5.4-2.1 1-.4.6-.6 1.3-.5 1.9l-1.8 2.1c-3.8-5.1-4.2-11.9-.6-16.6m22.6-2.7c.3-.2 1.1-.6 2.5-1.3-.6 1.4-1.1 2.2-1.3 2.5-.2.2-.4.3-.5.3-.2 0-.4-.02-.6-.22-.2-.2-.26-.44-.26-.56 0-.2 0-.4.2-.6m-9.9 5.3c-.23 0-.5-.1-.7-.3-.22-.2-.4-.5-.42-.7 0-.2 0-.4.15-.6.2-.27.47-.3.6-.3.26 0 .5.1.7.2.26.2.4.4.46.7 0 .1 0 .3-.06.43l-.3.3c-.2.07-.3.1-.4.1m-5.1 10.6c2.8-3.13 5.6-6.14 7.6-8.3l.6-.63v-.1c1.34-1.44 2.2-2.38 2.36-2.5.2-.2.44-.25.57-.25.1 0 .36.03.56.23.3.3.3.83 0 1.13-.35.38-5.76 5.47-11.5 10.67l-2.3 2.1 2.1-2.3m18.6-6.05c-2-1.1-2.7-1.64-3.24-3.25-.1-.3-.2-.67-.3-1.13 0-.3.02-.63 0-.94h.4c1 0 2-.4 2.73-1.13.7-.7 1.98-3.1 3.6-7 .2-.5.2-1.08-.1-1.54-.3-.5-.8-.76-1.4-.76h-.3l-.3.14c-3.9 1.7-6.3 2.9-7 3.66l-.3.3c-.4-.5-.95-1-1.6-1.44-7.23-4.9-16.53-1.74-21 4-4.64 6-4 14.6 1 20.95l-1.24 1.5c-2.8 3.3-4.16 4.95-2.8 6.28.3.3.7.5 1.2.5.6 0 1.3 0 6.6-4.6 3.5 2.6 7.6 4.04 11.76 4.04.4 0 .8 0 1.2-.06 4.7-.3 8.8-2.4 11.5-5.95 1.3-1.64 3-4.2 3.2-7 .2-3-1-5.2-3.6-6.55" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M43.96 18.56c.9-1.15.68-2.8-.47-3.7-1.2-.88-2.8-.67-3.7.48-.9 1.15-.7 2.8.4 3.7 1.1.88 2.8.67 3.7-.48m8.4 6.62c-1.2-.9-2.8-.68-3.7.47-.9 1.15-.7 2.8.4 3.7 1.1.88 2.8.67 3.7-.48.8-1.15.6-2.8-.5-3.7m7.3-2.45c-1.2-.9-2.8-.68-3.7.47-.9 1.1-.7 2.8.5 3.6 1.1.9 2.8.7 3.7-.5.9-1.2.6-2.8-.5-3.7" }))));
};
Art.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Art.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Art);


/***/ }),

/***/ "./src/components/Icon/Children.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Children = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "31", height: "35", viewBox: "51 0 31 35" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M75.9 31.37H56.94c-1.37 0-2.4-1.2-2.4-2.58v-8.9c.7.54 1.9.9 3.03.9h1.9v2.6c0 .1.1.2.23.2h2.73c.13 0 .33-.1.33-.2v-2.6h7.5v2.6c0 .1 0 .2.14.2h2.73c.13 0 .18-.1.18-.2v-2.6h2c1.15 0 2.27-.36 3.2-.9v8.85c0 1.36-1.2 2.57-2.56 2.57m-15.5-24.6H72.4c3.3 0 6.07 2.7 6.07 6v4.5c-.7.96-1.92 1.7-3.2 1.7H73.3v-4.2c0-.12-.04-.24-.17-.24H70.4c-.13 0-.14.1-.14.2v4.2h-7.5v-4.2c0-.12-.2-.24-.33-.24H59.7c-.12 0-.23.1-.23.24v4.2h-1.9c-1.28 0-2.32-.74-3.02-1.7v-4.5c0-3.3 2.6-5.98 5.88-5.98m15.22-2.4V.74c0-.25-.32-.55-.58-.55h-5.3c-.25 0-.45.3-.45.53V3.7h-5.86V.74c0-.26-.15-.56-.4-.56h-5.3c-.26 0-.4.3-.4.56v3.6c-3.52 1.26-5.86 4.55-5.86 8.4V28.8c0 3 2.42 5.37 5.44 5.37H75.9c3.02 0 5.38-2.37 5.38-5.4V12.74c0-3.84-2.35-7.13-5.63-8.4" })));
};
Children.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Children.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Children);


/***/ }),

/***/ "./src/components/Icon/Disability.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Disability = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "35", height: "36", viewBox: "20 0 35 36" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M46.42 13.32c.48 0 .65.08.66.07.02 0 .1.2.1.7v2.3H32v-3.1h14.42zm4.96 16.43c0 1.5-1.23 2.73-2.73 2.73s-2.72-1.22-2.72-2.73c0-.96.5-1.8 1.25-2.28v2.62c0 .8.7 1.5 1.57 1.5.87 0 1.57-.7 1.57-1.6v-2.5c.64.5 1.06 1.3 1.06 2.13zm-21.33 2.73c-3.54 0-6.43-2.88-6.43-6.43 0-3.14 2.26-5.76 5.24-6.32v7.22c0 .87.7 1.57 1.57 1.57.87 0 1.57-.7 1.57-1.57v-7.03c2.6.83 4.47 3.26 4.47 6.13 0 3.55-2.88 6.43-6.42 6.43zm-1.2-15.93c-4.7.6-8.37 4.62-8.37 9.5 0 5.28 4.3 9.58 9.57 9.58 5.27 0 9.56-4.3 9.56-9.58 0-2.48-.9-4.74-2.5-6.44h10.1v4.5c-2.5.7-4.4 3-4.4 5.7 0 3.3 2.7 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-2.6-1.8-4.9-4.2-5.6v-10c0-3.24-2.1-3.93-3.9-3.93H32v-5.1c0-3.04-1.36-4.4-4.42-4.4h-3.96c-.86 0-1.57.7-1.57 1.57 0 .9.7 1.6 1.57 1.6h3.96c.92 0 1.13.16 1.13.16s.2.2.2 1.1v11.4z" })));
};
Disability.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Disability.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Disability);


/***/ }),

/***/ "./src/components/Icon/Education.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Education = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "38", height: "37", viewBox: "22 0 38 37" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M41 3.5l12.85 4.85-6.08 2.3-5.83-3.5c-.74-.46-1.7-.22-2.15.53-.48.74-.24 1.7.5 2.16l3.7 2.22-3 1.14-12.86-4.85L41 3.5zm8.48 13.7c-.03.2-.38.54-1.05.9v-4.35l1.05-.4v3.86zm-8.6 2.36c-5.75 0-8.52-1.8-8.6-2.34h-.07v-3.98l8.17 3.08c.2.08.43.12.65.12.23 0 .45-.04.66-.12l3.64-1.38v4.2c-1.2.25-2.68.42-4.43.42zm6.5 13.64h-1.04v-1.8c0-.32.22-.56.52-.56.3 0 .53.24.53.56v1.8zm.06-6.52c0 .3-.25.55-.55.55-.3 0-.58-.25-.58-.55 0-.13.05-.25.13-.35.13.04.26.06.4.06.15 0 .3-.06.43-.1.1.1.13.22.13.36zM23.8 10.06l5.27 2v5.42h.08c.24 2.56 3.92 5.22 11.72 5.22 1.66 0 3.13-.13 4.42-.34v1c-1.26.6-2.1 1.85-2.1 3.32 0 .9.3 1.7.83 2.35-.53.65-.85 1.47-.85 2.37v4.95h7.32V31.4c0-.88-.3-1.7-.83-2.33.54-.65.87-1.48.87-2.4 0-1.48-.88-2.76-2.15-3.35v-1.77c2.67-1.02 4.02-2.56 4.16-4.07v-5.3l5.6-2.12c.7-.27 1.2-.94 1.2-1.72 0-.77-.5-1.44-1.2-1.7L41.64.37c-.42-.16-.9-.16-1.3 0L23.8 6.63c-.72.27-1.2.94-1.2 1.7 0 .8.48 1.46 1.2 1.73z" })));
};
Education.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Education.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Education);


/***/ }),

/***/ "./src/components/Icon/Emergencies.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Emergencies = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "35", viewBox: "36 0 33 35", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("defs", null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { id: "a", d: "M15.35 24.3c4.27 0 12.56-.9 12.56-.9V12.6C27.9 5.64 22.3 0 15.38 0 8.42 0 2.8 5.64 2.8 12.6v10.8s6.92.9 12.55.9z" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("mask", { id: "b", width: "25.12", height: "24.3", x: "0", y: "0", fill: "#fff" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("use", { xlinkHref: "#a" }))),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { fill: "none", fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { transform: "translate(37 9.942)" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", { width: "29.81", height: "5.4", y: "19.56", fill: color, rx: "2" }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("use", { stroke: color, strokeWidth: "6", mask: "url(#b)", xlinkHref: "#a" }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { stroke: color, strokeWidth: "2", d: "M16.7 6.8c-.33 0 4.08 0 4.76 4.55", strokeLinecap: "round", strokeLinejoin: "round" })),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { stroke: color, strokeWidth: "3", d: "M63.83 10.5l3.37-3.2m-14.58-.76L52.54 2m-11.37 8.5L37.8 7.3", strokeLinecap: "round" }))));
};
Emergencies.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Emergencies.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Emergencies);


/***/ }),

/***/ "./src/components/Icon/Gardens.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Gardens = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "34", viewBox: "34 0 34 34" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M48.8 28.8l8.86-3.34L62.2 30c-1.62.43-3.3.65-5 .65-2.96 0-5.8-.64-8.4-1.85zm-7.15-5.68l9.87-3.8 4.6 4.6-9.6 3.62c-1.2-.77-2.33-1.67-3.36-2.7-.54-.55-1.04-1.12-1.5-1.72zm6.5-19.48l-2.6 6.9-6.38-6.37c1.83-.54 3.72-.82 5.64-.82 1.15 0 2.26.1 3.35.3zm-1.08 8.43l3.03-8c1.9.52 3.7 1.32 5.36 2.38l-3.78 10.23-4.6-4.6zM45.5 13.3l4.5 4.5-9.54 3.66c-1.07-1.67-1.86-3.48-2.38-5.37l7.4-2.8zM38 5.8l5.96 5.95-6.32 2.4c-.47-2.75-.37-5.6.35-8.36zm23.5 6.7l-3.8 10.2-4.48-4.48 3.9-10.58c.6.47 1.17.98 1.72 1.52 1.02 1.02 1.9 2.14 2.67 3.33zm2.32 16.32l-4.58-4.58 3.53-9.47c2.04 4.35 2.45 9.34 1.05 14.05zM60.94 7.06C56.48 2.6 50.64.38 44.8.38c-2.8 0-5.63.52-8.3 1.56-.25.1-.46.3-.56.57-3.2 8.2-1.48 17.84 5.12 24.45 4.46 4.45 10.3 6.68 16.13 6.68 2.8 0 5.62-.52 8.3-1.56.24-.1.45-.3.55-.57 3.2-8.2 1.48-17.83-5.12-24.44z" })));
};
Gardens.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Gardens.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Gardens);


/***/ }),

/***/ "./src/components/Icon/Health.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Health = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "32", viewBox: "52 0 34 32" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M72.83 31.1c-.68 0-1.28-.44-1.46-1.1L68 17.6h-2.82c-.62 0-1.18-.4-1.4-.98l-2.26-5.8-2.45 5.84c-.23.56-.78.94-1.4.94H53.9c-.84 0-1.52-.66-1.52-1.5 0-.83.68-1.48 1.52-1.48h2.77l3.5-8.4c.25-.58.8-.97 1.43-.95.6 0 1.16.4 1.38.98l3.24 8.37h2.93c.68 0 1.28.42 1.46 1.08l1.75 6.33 2.7-19.95c.1-.7.7-1.26 1.4-1.3.73-.05 1.37.45 1.56 1.14l3.37 12.7h2.74c.85 0 1.53.65 1.53 1.5 0 .82-.68 1.48-1.52 1.48h-3.9c-.7 0-1.3-.47-1.45-1.14l-1.72-6.48-2.7 19.8c-.1.73-.67 1.27-1.4 1.32h-.1" })));
};
Health.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Health.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Health);


/***/ }),

/***/ "./src/components/Icon/InMemory.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var InMemory = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "26", height: "36", viewBox: "31 -1 26 36" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { fill: color, fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M34.14 29.83v-3.57c2.77.86 6.6 1.04 9.36 1.04 2.77 0 7.05-.18 9.36-1.04v3.57c-.46.5-4.2 1.23-9.36 1.23-5.15 0-8.44-.73-9.36-1.23m9.7-7.02c3.68 0 6.38.4 7.97.8-1.5.4-4.2.8-7.9.8s-6.4-.4-8-.7c1.6-.4 4.3-.8 8-.8m-.3-2.9c-4.5 0-12.3.5-12.3 3.7v6.7c0 3.3 7.8 3.7 12.38 3.7S56 33.7 56 30.4v-6.7c0-3.2-7.8-3.7-12.34-3.7" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M44.2 23.6h-.98c-.53 0-.96-.6-.96-1.3v-4.6c0-.72.43-1.3.96-1.3h.97c.5 0 .9.58.9 1.3v4.6c0 .7-.5 1.3-1 1.3" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M43.6 10.48c.15 1.12.7 1.6 1.26 2.1.52.45 1.1.97 1.18 1.97.07 1.17-.7 2.2-1.8 2.44h-.35c-.7 0-1.3-.2-1.7-.6-.5-.4-.8-1-.8-1.6-.1-1.7.6-3.2.9-3.9l.1-.2c.2-.5.3-.8.7-.7 0 0 .3 0 .4.4" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M46.94 13.55c-.14.95-.64 1.8-1.4 2.35-.76.57-1.7.8-2.63.66-.9-.15-1.7-.66-2.3-1.43-.5-.77-.8-1.72-.6-2.67.4-2.5 1.9-5.1 3.3-7.04.5 1.83 1.5 3.13 2.3 4.26 1.1 1.52 1.7 2.4 1.5 3.87m.9-5.62C46.7 6.3 45.58 4.8 45.8 1.8v-.36c0-.8-.63-1.44-1.4-1.44-.5 0-.93.3-1.2.7-.2.22-.3.35-.46.55C41.2 3.1 37.77 7.5 37.07 12c-.26 1.74.16 3.46 1.17 4.87 1.02 1.4 2.52 2.32 4.2 2.6.35.04.68.07 1 .07 1.37 0 2.68-.44 3.8-1.27 1.4-1.03 2.3-2.55 2.55-4.27.4-2.77-.9-4.52-2-6.07" }))));
};
InMemory.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
InMemory.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (InMemory);


/***/ }),

/***/ "./src/components/Icon/InternationalAid.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var InternationalAid = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "37", viewBox: "52 0 30 37" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M69.62 32.37h-1.57v1.58h-1.57v-1.58H64.9V30.8h1.58v-1.57h1.57v1.57h1.57v1.57zM56.3 13.84c.4-.62 1.33-1 2.36-1 1.17 0 2.2.5 2.5 1.28h-.04l.1.27v.1h.04l1.9 5.6-6.87-6.37zm16.45.7h.03c0-.03 0-.07.02-.12l.2-.54h-.04c.37-.65 1.25-1.03 2.27-1.03 1.03 0 1.97.37 2.37 1l-6.82 6.22 1.97-5.52zm-5.8 6.95l-2.5-7.4c.26-.8 1.3-1.3 2.5-1.3 1.26 0 2.27.8 2.58 1.4l-2.6 7.2zm0-17.9c4.4 0 8.16 2.43 9.88 6.22-.5-.1-1.04-.2-1.6-.2-1.62 0-3.06.6-4.07 1.53-1.06-.9-2.56-1.5-4.2-1.5-1.64 0-3.1.6-4.16 1.5-1.04-.9-2.5-1.5-4.14-1.5-.55 0-1.1.06-1.6.2 1.72-3.8 5.5-6.28 9.9-6.28zm5.8 31.7v-7.9c0-.3-.23-.3-.52-.3H68l.2-.3h.18l.1-.38L81.13 15v-.7c0-7.72-6.4-14-14.13-14-7.72 0-14.13 6.3-14.13 14v.7l12.4 11.3.14.45.3.03.3.33h-3.7c-.3 0-.45.1-.45.4v7.9c0 .3.18.7.47.7h10c.3 0 .53-.4.53-.67z" })));
};
InternationalAid.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
InternationalAid.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (InternationalAid);


/***/ }),

/***/ "./src/components/Icon/Lgbt.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Lgbt = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { width: "24px", height: "33px", viewBox: "4 0 24 33", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { id: "icon-lgbtq-med-grey", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", transform: "translate(4.000000, 0.000000)" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { id: "Page-1", fill: color, fillRule: "evenodd" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { id: "Icons-med-(26px)" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { id: "icon-/-lgbtq-/-med-/-grey" },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { d: "M9.41389339,20.1774517 C6.40048552,20.1774517 3.94881608,17.7146403 3.94881608,14.6865299 C3.94881608,11.6586345 6.40048552,9.19517816 9.41389339,9.19517816 C12.4273013,9.19517816 14.8785428,11.6586345 14.8785428,14.6865299 C14.8785428,17.7146403 12.4273013,20.1774517 9.41389339,20.1774517 M22.6498281,0.916666666 L15.9425516,0.916666666 C15.6841434,0.916666666 15.4745075,1.12731034 15.4745075,1.38696092 L15.4745075,3.26813793 C15.4745075,3.5277885 15.6841434,3.73843219 15.9425516,3.73843219 L18.3240572,3.73843219 L14.1792577,7.90294368 C12.8305293,6.94322528 11.1885248,6.37362759 9.41389339,6.37362759 C4.85196139,6.37362759 1.14055184,10.1026655 1.14055184,14.6865299 C1.14055184,18.7882781 4.11566908,22.1970517 8.00976126,22.8700368 L8.00976126,26.1831609 L4.96854457,26.1831609 C4.71013635,26.1831609 4.50050053,26.3938046 4.50050053,26.6534552 L4.50050053,28.5346322 C4.50050053,28.7942828 4.71013635,29.0049265 4.96854457,29.0049265 L8.00976126,29.0049265 L8.00976126,31.6130391 C8.00976126,31.8726897 8.21939709,32.0833334 8.47780535,32.0833334 L10.3499814,32.0833334 C10.6083897,32.0833334 10.8180255,31.8726897 10.8180255,31.6130391 L10.8180255,29.0049265 L13.9533644,29.0049265 C14.2119865,29.0049265 14.4214085,28.7942828 14.4214085,28.5346322 L14.4214085,26.6534552 C14.4214085,26.3938046 14.2119865,26.1831609 13.9533644,26.1831609 L10.8180255,26.1831609 L10.8180255,22.8700368 C14.7116899,22.1970517 17.6865932,18.7882781 17.6865932,14.6865299 C17.6865932,12.9031517 17.1197208,11.2532529 16.1645944,9.89782529 L20.3098218,5.73309885 L20.3098218,8.12648391 C20.3098218,8.38634943 20.5192436,8.59677816 20.7778659,8.59677816 L22.6498281,8.59677816 C22.9084502,8.59677816 23.117872,8.38634943 23.117872,8.12648391 L23.117872,1.38696092 C23.117872,1.12731034 22.9084502,0.916666666 22.6498281,0.916666666", id: "Fill-1" })))))));
};
Lgbt.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Lgbt.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Lgbt);


/***/ }),

/***/ "./src/components/Icon/LocalCommunity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var LocalCommunity = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "36", height: "30", viewBox: "52 0 36 30" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M71.98 26.62V18.3c0-1.2-1.14-2.16-2.32-2.16h-5.22c-1.03 0-1.88.85-1.88 1.88v8.6h-3.14V12.64l7.62-4.52 8.08 4.8v13.7h-3.14zm7.56-11.03c.25.1.5.2.76.2.54 0 1.04-.3 1.34-.8.44-.8.2-1.7-.56-2.2L70.15 6.3c.23-.03.46-.04.7 0H71l.37-.15.06-.26c.3-1.3 1.43-2.2 2.7-2.2.9 0 1.75.43 2.27 1.2l.15.14.24.1.1-.04.2-.04V5c.9-.9 2.42-1.1 3.5-.4 1.04.7 1.5 2.1 1.03 3.3l-.1.24.26.46.3.05c1.4.2 2.44 1.4 2.44 2.78 0 1.2-.77 2.26-1.87 2.63l-.25.05-.2.45.1.16c.18 1.08-.2 2.16-1.1 2.78-.9.67-2.52.66-3.04.05V14.8l1.3.8zm5.53-9.2C84.9 4.6 83.95 3 82.47 2c-1.57-1-3.6-1.2-5.37-.57-.9-.52-1.9-.8-2.94-.8-2.02 0-3.85 1-4.94 2.7-1.07.26-2.03.78-2.8 1.5l-.23.1L53 12.8c-.74.45-1 1.4-.54 2.16.44.74 1.42 1 2.16.54l1.66-.98v13.3c0 1.17.94 1.95 2.12 1.95h5.3c1.1 0 2-.72 2-1.84V19.3h3.14v8.63c0 1.12.72 1.84 1.83 1.84 0 0 7.25.18 8.1.18.88 0 1.58-.7 1.58-1.57v-7.74c0 .28 1.2.13 1.4.1 2.2-.32 3.42-2.62 3.72-4.62 1.43-1.12 2.3-2.84 2.3-4.67 0-2-1.02-3.88-2.7-4.97z" })));
};
LocalCommunity.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
LocalCommunity.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (LocalCommunity);


/***/ }),

/***/ "./src/components/Icon/Politics.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Politics = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", viewBox: "0 0 24 24" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { transform: "translate(-128.000000, -2555.000000)", fill: "#999999" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", { transform: "translate(128.000000, 2555.000000)" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, d: "M20.9839194,20.62327 L20.6230408,20.9841485 C20.4954653,21.1114186 20.2798854,21.1114186 20.1524626,20.9841485 L12.8963905,13.7280764 L13.7278472,12.8966196 L20.9839194,20.1523862 C21.111495,20.2801146 21.111495,20.4955416 20.9839194,20.62327 L20.9839194,20.62327 Z M9.50272679,14.2981178 L6.20333156,10.9985698 L10.9984934,6.20340796 L14.2980414,9.50295597 L9.50272679,14.2981178 Z M7.99932095,17.5855958 L2.91585358,12.514504 L3.89948435,11.5184976 L8.97684032,16.5958536 L7.99932095,17.5855958 Z M12.502052,2.91592997 L17.5801719,7.99236923 L16.6017358,8.9831809 L11.5245326,3.90582493 L12.502052,2.91592997 Z M22.3956541,18.7406515 L15.1397347,11.4847321 L15.8106143,10.8138525 C16.0607236,10.9211077 16.327792,10.9762631 16.5956244,10.9762631 C17.1045517,10.9762631 17.6137846,10.7823788 18.0012477,10.3947629 L18.9972541,9.3987565 L18.9972541,9.3987565 C19.3718833,9.02412732 19.578296,8.52497825 19.578296,7.99313316 C19.578296,7.46144085 19.3718833,6.96229178 18.9972541,6.5876626 L13.9137867,1.50419523 C13.1387077,0.729421751 11.8776191,0.729268966 11.1025401,1.50434801 L10.1066865,2.50020159 C9.73190451,2.87483077 9.52549178,3.37397984 9.52549178,3.90582493 C9.52549178,4.1808382 9.58171671,4.44668435 9.68683289,4.69144615 L4.69060584,9.68767321 C3.96518196,9.37690822 3.09140371,9.51548435 2.5001252,10.1067629 L1.50411883,11.1026164 C1.12948966,11.4772456 0.923076923,11.9763947 0.923076923,12.5083926 C0.923076923,13.0402377 1.12948966,13.5393867 1.50411883,13.9138631 L6.58758621,18.9974833 C6.97504934,19.3847936 7.48397666,19.578678 7.99305676,19.578678 C8.50213687,19.578678 9.01121698,19.3847936 9.39883289,18.9973305 L10.3946865,18.0013241 C10.7694684,17.626695 10.9757284,17.1275459 10.9757284,16.5957008 C10.9757284,16.3206875 10.9196562,16.0548414 10.8145401,15.8100796 L11.4846557,15.1398111 L18.7405751,22.3958833 C19.1795268,22.834835 19.7645411,23.0763883 20.3877517,23.0763883 C21.0109623,23.0763883 21.5958239,22.834835 22.0347756,22.3958833 L22.3956541,22.0350048 C23.3039618,21.1268499 23.3039618,19.6489592 22.3956541,18.7406515 L22.3956541,18.7406515 Z" }))))));
};
Politics.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Politics.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Politics);


/***/ }),

/***/ "./src/components/Icon/SocialWelfare.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var SocialWelfare = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "28", height: "34", viewBox: "46 0 28 34" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M70.45 22.67c0 .65-.45 1.14-1.06 1.14-.7 0-1.1-.5-1.1-1.1v-3.8c0-.6.4-1.1 1-1.1s1 .5 1 1.2v3.85zM49.13 29.5V15.65c2.75.84 6.18.94 7.68.94s5.2-.1 7.7-1v13.9c-.7.4-3.4 1.1-7.7 1.1-4.2 0-6.7-.7-7.6-1.2zm7.7-17.4c3.13 0 5.4.37 6.7.76-1.3.4-3.57.77-6.7.77-3.13 0-5.4-.38-6.68-.77 1.28-.4 3.55-.77 6.68-.77zm12.55 2.63c-.7 0-1.45.17-1.9.47v-2.47c0-.24-.1-.46-.2-.66-1.13-2.7-8.16-2.94-10.44-2.94-2.28 0-9.34.23-10.48 2.94-.1.2-.2.42-.2.66V30c0 .15.07.3.1.45.02.03.05.06.06.1 0 0 .02 0 .03.03 1 2.8 8.17 3.04 10.48 3.04 2.3 0 9.47-.24 10.48-3.04l.1-.04c0-.03.1-.06.1-.1.1-.14.1-.3.1-.45v-3.7c.5.3 1.28.4 1.9.4 2.3 0 4.1-1.8 4.1-4.1v-3.8c0-2.3-1.8-4.1-4.04-4.1zM58.44 8.15c-.33 0-.64-.16-.83-.45-.3-.46-.1-1.06.3-1.36.3-.2.8-.65.8-.94 0-.03 0-.12-.1-.3-.7-.72-1-1.85-.9-2.8.2-.82.7-1.47 1.5-1.83.5-.22 1.1 0 1.3.5.3.5 0 1.07-.4 1.3-.25.1-.3.26-.33.4-.06.3.1.8.36 1.05.7.7.78 1.42.7 1.9C60.56 6.98 59.2 7.9 59 8c-.16.1-.34.15-.52.15m-3.75 0c-.32 0-.64-.16-.83-.45-.3-.46-.16-1.06.3-1.36.3-.2.76-.65.8-.94 0-.03 0-.12-.17-.3-.73-.72-1.1-1.85-.9-2.8.14-.82.66-1.47 1.45-1.83.5-.22 1.08 0 1.3.5.23.5 0 1.07-.5 1.3-.24.1-.3.26-.32.4-.06.3.1.8.36 1.05.7.7.75 1.42.7 1.9-.14 1.36-1.5 2.28-1.67 2.38-.17.1-.35.15-.54.15" })));
};
SocialWelfare.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
SocialWelfare.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (SocialWelfare);


/***/ }),

/***/ "./src/components/Icon/Sports.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);


var Sports = function (_a) {
    var color = _a.color;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "33", height: "33", viewBox: "11 0 33 33" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path", { fill: color, fillRule: "evenodd", d: "M25.776 14.6c3.05-3.056 4.625-7.025 4.74-11.03 2.352.55 4.512 1.743 6.263 3.497 1.75 1.753 2.94 3.915 3.49 6.27-4 .115-7.97 1.693-11.02 4.75-3.05 3.055-4.63 7.024-4.74 11.028-2.35-.55-4.52-1.742-6.27-3.496-1.79-1.79-2.95-3.98-3.49-6.27 3.99-.12 7.95-1.7 11-4.75zm-2.22-2.224c-2.442 2.445-5.68 3.805-9.13 3.838 0-.097.003-.195.007-.292.003-.09.004-.18.01-.27.005-.103.013-.206.02-.31.01-.113.018-.227.03-.34.007-.076.018-.152.027-.228.017-.14.034-.283.055-.424l.024-.135c.02-.17.05-.342.09-.512l.01-.045c.43-2.052 1.34-3.99 2.68-5.633l.06-.076c.11-.14.23-.28.35-.41.14-.16.29-.32.45-.48.15-.16.31-.31.47-.45l.24-.21c.08-.07.16-.15.25-.22.1-.09.21-.17.31-.25l.18-.15c.13-.1.26-.19.39-.28l.12-.09c.14-.1.29-.19.44-.29l.085-.06c.16-.1.33-.198.5-.29l.042-.027c.18-.1.36-.19.55-.28 1.71-.818 3.58-1.257 5.522-1.275-.035 3.4-1.39 6.7-3.83 9.142zm12.752 13.692c-.056.052-.114.1-.172.15-.104.09-.208.184-.315.272-.09.076-.18.148-.28.222-.07.057-.14.116-.22.172-.12.09-.24.174-.36.26-.05.034-.1.072-.15.106-.14.096-.29.187-.43.277l-.1.063c-.16.097-.32.19-.49.28l-.05.032c-.18.098-.36.192-.55.282-1.7.817-3.58 1.255-5.52 1.273.04-3.405 1.4-6.704 3.83-9.147 2.45-2.445 5.69-3.805 9.14-3.838-.03 3.374-1.37 6.643-3.76 9.08l-.06.067c-.15.15-.31.3-.47.44zm2.574-21.225c-2.462-2.466-5.46-4.05-8.65-4.6l.058-.08C29.37.163 28.444 0 27.516 0c-4.156 0-8.312 1.628-11.483 4.803-.224.224-.437.474-.645.707-.065.073-.126.158-.19.23-.14.166-.28.337-.414.507-.067.084-.133.172-.198.258-.128.17-.253.34-.374.513-.056.08-.113.16-.168.243-.142.21-.278.43-.41.64-.025.05-.053.09-.078.13-.16.27-.31.54-.453.82l-.052.11c-.12.24-.23.48-.34.72l-.09.21-.27.66c-.02.07-.05.13-.07.2-.09.26-.18.51-.26.76-.21.7-.36 1.31-.47 1.93-.05.32-.1.62-.14.92-.04.38-.07.68-.09.98-.28 4.52 1.29 9.11 4.72 12.55 3.17 3.17 7.33 4.76 11.49 4.76 3.88 0 7.75-1.38 10.83-4.142.23-.2.44-.41.66-.62.23-.225.44-.455.65-.69.07-.072.13-.147.19-.22l.42-.5.2-.257c.13-.17.25-.34.377-.513l.16-.25c.14-.21.276-.424.407-.64l.08-.13c.16-.27.31-.54.45-.815l.05-.11c.12-.232.237-.47.344-.71l.09-.203.27-.66.074-.2c.09-.25.178-.5.258-.75.21-.69.36-1.3.473-1.92.06-.32.1-.62.14-.91.045-.38.07-.678.09-.977 0-.007-.114-.014-.114-.02.08-1.27.2-2.544-.32-3.8 0-3.195-1.935-6.257-4.398-8.723z" })));
};
Sports.propTypes = {
    color: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
};
Sports.defaultProps = {
    color: '#999999',
};
/* harmony default export */ __webpack_exports__["a"] = (Sports);


/***/ }),

/***/ "./src/components/Icon/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animals__ = __webpack_require__("./src/components/Icon/Animals.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Animals__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Art__ = __webpack_require__("./src/components/Icon/Art.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Art__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Children__ = __webpack_require__("./src/components/Icon/Children.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Children__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Disability__ = __webpack_require__("./src/components/Icon/Disability.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Disability__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Education__ = __webpack_require__("./src/components/Icon/Education.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Education__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Emergencies__ = __webpack_require__("./src/components/Icon/Emergencies.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Emergencies__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Gardens__ = __webpack_require__("./src/components/Icon/Gardens.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__Gardens__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Health__ = __webpack_require__("./src/components/Icon/Health.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__Health__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InMemory__ = __webpack_require__("./src/components/Icon/InMemory.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__InMemory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InternationalAid__ = __webpack_require__("./src/components/Icon/InternationalAid.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__InternationalAid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LocalCommunity__ = __webpack_require__("./src/components/Icon/LocalCommunity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__LocalCommunity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SocialWelfare__ = __webpack_require__("./src/components/Icon/SocialWelfare.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__SocialWelfare__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Sports__ = __webpack_require__("./src/components/Icon/Sports.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__Sports__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Lgbt__ = __webpack_require__("./src/components/Icon/Lgbt.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_13__Lgbt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Politics__ = __webpack_require__("./src/components/Icon/Politics.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_14__Politics__["a"]; });

















/***/ }),

/***/ "./src/containers/HomeView.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("./node_modules/redux/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_helpers_asyncConnect__ = __webpack_require__("./src/helpers/asyncConnect.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Home_Home__ = __webpack_require__("./src/components/Home/Home.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___ = __webpack_require__("./src/redux/modules/home/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_modules_avatars__ = __webpack_require__("./src/redux/modules/avatars.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__redux_modules_carousel__ = __webpack_require__("./src/redux/modules/carousel.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DeletePage_DeletePageSuccessAlert__ = __webpack_require__("./src/components/DeletePage/DeletePageSuccessAlert.tsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__redux_modules_page_deletePage__ = __webpack_require__("./src/redux/modules/page/deletePage.ts");
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};










var fetchData = function (dispatch) { return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["f" /* loadHome */])()); };
function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
        closeDeletePageSuccessAlert: __WEBPACK_IMPORTED_MODULE_9__redux_modules_page_deletePage__["b" /* closeDeletePageSuccessAlert */],
        changePagesFilter: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["a" /* changePagesFilter */],
        loadCategoryPage: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["d" /* loadCategoryPage */],
        loadFilteredPages: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["e" /* loadFilteredPages */],
        getStarted: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["c" /* getStarted */],
        seeMoreFaq: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["g" /* seeMoreFaq */],
        selectCard: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["h" /* selectCard */],
        loadAvatars: __WEBPACK_IMPORTED_MODULE_6__redux_modules_avatars__["b" /* loadAvatars */],
        slideCarousel: __WEBPACK_IMPORTED_MODULE_7__redux_modules_carousel__["b" /* slideCarousel */],
        loadHome: __WEBPACK_IMPORTED_MODULE_5_src_redux_modules_home___["f" /* loadHome */],
        onPageView: function () { return ({
            type: 'HOME_PAGE_VIEW',
            meta: {
                analytics: {
                    event: 'page view',
                    subtype: 'home',
                },
            },
        }); },
    }, dispatch);
}
function mapStateToProps(state) {
    return {
        carouselPages: state.home.carouselPages,
        filteredPages: state.home.filteredPages,
        filter: state.home.filter,
        isLoading: state.home.isLoading,
        activePagesCount: state.home.activePagesCount,
        avatars: state.avatars.avatars,
        hasPageBeenDeleted: state.page.hasPageBeenDeleted,
    };
}
var HomeView = /** @class */ (function (_super) {
    __extends(HomeView, _super);
    function HomeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeView.prototype.componentDidMount = function () {
        this.toggleChromeStartFundraisingButton(false);
        this.props.onPageView();
    };
    HomeView.prototype.componentWillUnmount = function () {
        this.toggleChromeStartFundraisingButton(true);
    };
    HomeView.prototype.toggleChromeStartFundraisingButton = function (toggle) {
        if (window.jg &&
            window.jg.chrome &&
            window.jg.chrome.toggleStartFundraisingButton) {
            window.jg.chrome.toggleStartFundraisingButton(toggle);
        }
    };
    HomeView.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null,
            this.props.hasPageBeenDeleted && (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_DeletePage_DeletePageSuccessAlert__["a" /* default */], { onClose: this.props.closeDeletePageSuccessAlert })),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_src_components_Home_Home__["a" /* default */], __assign({}, this.props))));
    };
    HomeView.propTypes = {
        onPageView: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        hasPageBeenDeleted: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        closeDeletePageSuccessAlert: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    };
    return HomeView;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_3_src_helpers_asyncConnect__["a" /* default */])(HomeView, {
    mapStateToProps: mapStateToProps,
    mapDispatchToProps: mapDispatchToProps,
    fetchData: fetchData,
    id: 'HOME_VIEW',
}));


/***/ })

});


// WEBPACK FOOTER //
// home-7e63d939b86002749d55.js